<template>
  <div class="mainContainer" @contextmenu.prevent="null" style="user-select: none; cursor: default;">
    <v-card v-if="navigation.searchVisible" :border="$vuetify.display.sm || $vuetify.display.xs ? null : 'e'" elevation="0" rounded="0" color="border" class="navigationContainer"> 
      <v-card elevation="0" rounded="0" color="primary" style="width: 100%; padding: 15px; display: flex; align-items: center;">
        <v-icon size="large" color="indigo">mdi-invoice-text</v-icon>
        <v-icon color="indigo" style="margin-right: 10px;">mdi-view-list</v-icon>
        <h4>LISTA DE ÓRDENES</h4>
        <div style="margin-left: auto; display: flex; gap: 5px;">
          <v-icon @click="selectCRMWhatsappConversationFromCRMWhatsappConversationsView(true)" :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" size="x-small" class="hoverableElement">mdi-magnify</v-icon>
          <v-icon @click="setDefaultValues()" :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" size="x-small" class="hoverableElement">mdi-backspace</v-icon>
          <v-icon @click="$generalFunctions.default.copyToClipboard(this, 'Búsqueda de conversaciones', 'a', null)" :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" size="x-small" class="hoverableElement">mdi-share-variant</v-icon>
          <v-icon v-if="navigation.searchVisible == true" @click="navigation.searchVisible = false" :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" size="x-small" class="hoverableElement hideSearchContainer">mdi-arrow-left-bottom-bold</v-icon>
        </div>
      </v-card> 
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <div class="navigationSearchContainer">
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros de la orden:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-text-field 
              v-bind="props"
              ref="CRMWhatsappInvoiceID"
              v-model="input.CRMWhatsappInvoiceID"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceID'); input.CRMWhatsappInvoiceID = null;" 
              :prepend-inner-icon="input.CRMWhatsappInvoiceID && /\S/.test(input.CRMWhatsappInvoiceID) ? 'mdi-barcode-off' : 'mdi-barcode'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              @update:model-value="updateURLSearchQuery()"
              type="number"
              label="Buscar por identificador interno"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              hide-spin-buttons
              style="margin-bottom: 15px;"
            >
            </v-text-field>
          </template>
          <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática a la orden. Si se coloca un identificador interno, se buscará la única orden que coincida con el mismo, ignorando el resto de filtros seleccionados. Al presionar el ícono de la izquierda se limpiará el identificador interno colocado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceCreationDatetime"
              v-model="input.CRMWhatsappInvoiceCreationDatetime"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceCreationDatetime'); input.CRMWhatsappInvoiceCreationDatetime = systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? Array.from({length: 30}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(29-i)); return d.toISOString().split('T')[0]; }) : Array.from({length: 7}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(6-i)); return d.toISOString().split('T')[0]; });" 
              :prepend-inner-icon="input.CRMWhatsappInvoiceCreationDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]"
              :max="new Date().toISOString().split('T')[0]"
              @update:model-value="updateURLSearchQuery()"
              prepend-icon=""
              label="Filtrar por fecha de creación"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de creación de la orden permite buscar todas las ordenes creadas en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de creación de la orden colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceLocalityStartDatetime"
              v-model="input.CRMWhatsappInvoiceLocalityStartDatetime"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceLocalityStartDatetime'); input.CRMWhatsappInvoiceLocalityStartDatetime.length = 0;" 
              :prepend-inner-icon="input.CRMWhatsappInvoiceLocalityStartDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]"
              :max="new Date().toISOString().split('T')[0]"
              @update:model-value="updateURLSearchQuery()"
              prepend-icon=""
              label="Filtrar por fecha de llegada a la localidad"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de llegada a la localidad permite buscar todas las ordenes que hayan llegado a la localidad en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de llegada a la localidad colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceLocalityEndDatetime"
              v-model="input.CRMWhatsappInvoiceLocalityEndDatetime"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceLocalityEndDatetime'); input.CRMWhatsappInvoiceLocalityEndDatetime.length = 0;" 
              :prepend-inner-icon="input.CRMWhatsappInvoiceLocalityEndDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]"
              :max="new Date().toISOString().split('T')[0]"
              @update:model-value="updateURLSearchQuery()"
              prepend-icon=""
              label="Filtrar por fecha de salida de la localidad"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de salida de la localidad permite buscar todas las ordenes que hayan salido de la localidad en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de salida de la localidad colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceShippingStartDatetime"
              v-model="input.CRMWhatsappInvoiceShippingStartDatetime"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingStartDatetime'); input.CRMWhatsappInvoiceShippingStartDatetime.length = 0;" 
              :prepend-inner-icon="input.CRMWhatsappInvoiceShippingStartDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]"
              :max="new Date().toISOString().split('T')[0]"
              @update:model-value="updateURLSearchQuery()"
              prepend-icon=""
              label="Filtrar por fecha de inicio de la entrega"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de inicio de la entrega permite buscar todas las ordenes que hayan iniciado la entrega en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de inicio de la entrega colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-date-input
              v-bind="props"
              ref="CRMWhatsappInvoiceShippingEndDatetime"
              v-model="input.CRMWhatsappInvoiceShippingEndDatetime"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingEndDatetime'); input.CRMWhatsappInvoiceShippingEndDatetime.length = 0"
              :prepend-inner-icon="input.CRMWhatsappInvoiceShippingEndDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :min="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? null : new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]"
              :max="new Date().toISOString().split('T')[0]"
              @update:model-value="updateURLSearchQuery()"
              prepend-icon=""
              label="Filtrar por fecha de fin de la entrega"
              variant="outlined"
              density="compact"
              multiple="range"
              autocomplete="off"
              hide-details
              style="margin-bottom: 15px;"
            ></v-date-input>
          </template>
          <span style="max-width: 400px; display: block;">El filtro por fecha de fin de la entrega permite buscar todas las ordenes que hayan finalizado la entrega en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de fin de la entrega colocada</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappContactID"
              v-model="input.CRMWhatsappContactID"
              v-model:search="input.CRMWhatsappContactIDSearch"
              @input="autocompleteCRMWhatsappContact()"
              :items="display.CRMWhatsappContact"
              item-title="CRMWhatsappContactName"
              item-value="CRMWhatsappContactID"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactID'); input.CRMWhatsappContactIDSearch = null; input.CRMWhatsappContactID = null;" 
              :prepend-inner-icon="(input.CRMWhatsappContactIDSearch && /\S/.test(input.CRMWhatsappContactIDSearch)) || input.CRMWhatsappContactID ? 'mdi-account-off' : 'mdi-account'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              @update:model-value="updateURLSearchQuery()"
              label="Filtrar por contacto"
              placeholder="Todos los contactos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            >
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El contacto asignado a la orden. Si se selecciona al menos un contacto, se buscaran todas las ordenes que tengan asignado al contacto seleccionado. Al presionar el ícono de la izquierda se limpiará el contacto seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityID"
              v-model="input.CRMLocalityID"
              v-model:search="input.CRMLocalityIDSearch"
              :items="systemInformationData.CRMLocalities"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMLocalityIDSearch = null; input.CRMLocalityID.length = 0; input.allCRMLocalityIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMLocalityID');"
              @update:model-value="updateURLSearchQuery(); input.allCRMLocalityIDSelected = input.CRMLocalityID.length == systemInformationData.CRMLocalities.filter(CRMLocality => CRMLocality.CRMLocalityID != null).length;"
              :prepend-inner-icon="(input.CRMLocalityIDSearch && /\S/.test(input.CRMLocalityIDSearch)) || input.CRMLocalityID.length > 0 ? 'mdi-store-off' : 'mdi-store'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              item-title="CRMLocalityName"
              item-value="CRMLocalityID"
              label="Filtrar por localidad"
              placeholder="Todas las localidades"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityIDSelected" 
                  @update:model-value="input.CRMLocalityID = input.allCRMLocalityIDSelected ? systemInformationData.CRMLocalities.filter(CRMLocality => CRMLocality.CRMLocalityID != null).map(CRMLocality => CRMLocality.CRMLocalityID) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == item.value).CRMLocalityColor : 'primary'" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityID = input.CRMLocalityID.filter(CRMLocalityID => CRMLocalityID != item.value); input.allCRMLocalityIDSelected = false; updateURLSearchQuery()">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityID.length - 2 }} localidad{{ input.CRMLocalityID.length - 2 == 1 ? '' : 'es' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La localidad a la que pertenece la orden. Si se coloca al menos una división de mapa, se buscarán todas las ordenes que pertenezcan a la localidad o localidades seleccionadas. Al presionar el ícono de la izquierda se limpiará la o las localidades seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las localidades disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMLocalityMapDivisionID"
              v-model="input.CRMLocalityMapDivisionID"
              v-model:search="input.CRMLocalityMapDivisionIDSearch"
              :items="display.CRMLocalityMapDivision"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMLocalityMapDivisionIDSearch = null; input.CRMLocalityMapDivisionID.length = 0; input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMLocalityMapDivisionID');"
              @update:model-value="input.allCRMLocalityMapDivisionIDSelected = input.CRMLocalityMapDivisionID.length == display.CRMLocalityMapDivision.filter(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID != null).length; updateURLSearchQuery(); "
              :prepend-inner-icon="(input.CRMLocalityMapDivisionIDSearch && /\S/.test(input.CRMLocalityMapDivisionIDSearch)) || input.CRMLocalityMapDivisionID.length > 0 ? 'mdi-map-marker-off' : 'mdi-map-marker'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              item-title="CRMLocalityMapDivisionName"
              item-value="CRMLocalityMapDivisionID"
              label="Filtrar por zona geográfica"
              placeholder="Todas las zonas geográficas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMLocalityMapDivisionIDSelected" 
                  @update:model-value="input.CRMLocalityMapDivisionID = input.allCRMLocalityMapDivisionIDSelected ? display.CRMLocalityMapDivision.filter(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID != null).map(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID) : []; updateURLSearchQuery();"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMLocalityMapDivisionID = input.CRMLocalityMapDivisionID.filter(CRMLocalityMapDivisionID => CRMLocalityMapDivisionID != item.value); input.allCRMLocalityMapDivisionIDSelected = false; updateURLSearchQuery()">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMLocalityMapDivisionID.length - 2 }} {{ input.CRMLocalityMapDivisionID.length - 2 == 1 ? 'división' : 'divisones' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La zona geográfica de entrega de la orden. Si se coloca al menos una división de mapa, se buscarán todas las ordenes entregadas en la zona o zonas geográficas seleccionadas. Al presionar el ícono de la izquierda se limpiará la o las zonas geográficas seleccionadas. Al presionar el ícono de la derecha se seleccionan todas zonas geográficas disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceCreationCRMAgentID"
              v-model="input.CRMWhatsappInvoiceCreationCRMAgentID"
              v-model:search="input.CRMWhatsappInvoiceCreationCRMAgentIDSearch"
              :items="systemInformationData.CRMAgents"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceCreationCRMAgentIDSearch = null; input.CRMWhatsappInvoiceCreationCRMAgentID.length = 0; input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceCreationCRMAgentID');"
              @update:model-value="input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = input.CRMWhatsappInvoiceCreationCRMAgentID.length == systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoiceCreationCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceCreationCRMAgentID') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoiceCreationCRMAgentIDSearch && /\S/.test(input.CRMWhatsappInvoiceCreationCRMAgentIDSearch)) || input.CRMWhatsappInvoiceCreationCRMAgentID.length > 0 ? 'mdi-briefcase-off' : 'mdi-briefcase-account'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              item-title="CRMAgentName"
              item-value="CRMAgentID"
              label="Filtrar por agente de venta"
              placeholder="Todos los agentes de venta"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceCreationCRMAgentID = input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected ? systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).map(CRMAgent => CRMAgent.CRMAgentID) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor : 'primary'" variant="flat" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ item.title }}</p>
                  </div>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceCreationCRMAgentID = input.CRMWhatsappInvoiceCreationCRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoiceCreationCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceCreationCRMAgentID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceCreationCRMAgentID.length - 2 }} vendedor{{ input.CRMWhatsappInvoiceCreationCRMAgentID.length - 2 == 1 ? '' : 'es' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El agente de venta de la orden. Si se coloca al menos un agente de venta, se buscarán todas las ordenes creadas por el o los agentes de venta seleccionados. Al presionar el ícono de la izquierda se limpiará el o los agentes de venta seleccionados. Al presionar el ícono de la derecha se seleccionan todos los agentes de venta disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceShippingCRMAgentID"
              v-model="input.CRMWhatsappInvoiceShippingCRMAgentID"
              v-model:search="input.CRMWhatsappInvoiceShippingCRMAgentIDSearch"
              :items="display.shippingCRMAgent"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceShippingCRMAgentIDSearch = null; input.CRMWhatsappInvoiceShippingCRMAgentID.length = 0; input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingCRMAgentID');"
              @update:model-value="input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected = input.CRMWhatsappInvoiceShippingCRMAgentID.length == display.shippingCRMAgent.filter(CRMAgent => CRMAgent.CRMAgentID != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoiceShippingCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingCRMAgentID') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoiceShippingCRMAgentIDSearch && /\S/.test(input.CRMWhatsappInvoiceShippingCRMAgentIDSearch)) || input.CRMWhatsappInvoiceShippingCRMAgentID.length > 0 ? 'mdi-truck-remove' : 'mdi-truck'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              item-title="CRMAgentName"
              item-value="CRMAgentID"
              label="Filtrar por agente de envío"
              placeholder="Todos los agentes de envío"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceShippingCRMAgentID = input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected ? display.shippingCRMAgent.filter(CRMAgent => CRMAgent.CRMAgentID != null).map(CRMAgent => CRMAgent.CRMAgentID) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor : 'primary'" variant="flat" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ item.title }}</p>
                  </div>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceShippingCRMAgentID = input.CRMWhatsappInvoiceShippingCRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoiceShippingCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingCRMAgentID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceShippingCRMAgentID.length - 2 }} agente{{ input.CRMWhatsappInvoiceShippingCRMAgentID.length - 2 == 1 ? '' : 'es' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El agente de envío de la orden. Si se coloca al menos un agente de envío, se buscarán todas las ordenes entregadas por el o los agentes de envío seleccionados. Al presionar el ícono de la izquierda se limpiará el o los agentes de envío seleccionados. Al presionar el ícono de la derecha se seleccionan todos los agentes de envío disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceState"
              v-model="input.CRMWhatsappInvoiceState"
              v-model:search="input.CRMWhatsappInvoiceStateSearch"
              :items="display.CRMWhatsappInvoiceState"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceStateSearch = null; input.CRMWhatsappInvoiceState.length = 0; input.allCRMWhatsappInvoiceStateSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceState');"
              @update:model-value="input.allCRMWhatsappInvoiceStateSelected = input.CRMWhatsappInvoiceState.length == display.CRMWhatsappInvoiceState.filter(state => state != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoiceState.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceState') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoiceStateSearch && /\S/.test(input.CRMWhatsappInvoiceStateSearch)) || input.CRMWhatsappInvoiceState.length > 0 ? 'mdi-timeline-remove' : 'mdi-timeline'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por estado"
              placeholder="Todos los estados"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceStateSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceState = input.allCRMWhatsappInvoiceStateSelected ? display.CRMWhatsappInvoiceState.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" :color="{'Orden generada': 'error', 'Orden en localidad': 'warning', 'Orden en entrega': 'teal', 'Orden entregada': 'success', 'Orden no entregada': 'gray', 'Orden cancelada': 'error'}[item.title]" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceState = input.CRMWhatsappInvoiceState.filter(state => state != item.value); input.allCRMWhatsappInvoiceStateSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoiceState.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceState') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceState.length - 2 }} {{ input.CRMWhatsappInvoiceState.length - 2 == 1 ? 'estado' : 'estados' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El estado de la orden. Si se coloca al menos un estado, se buscarán todas las ordenes con el o los estados seleccionados. Al presionar el ícono de la izquierda se limpiará el o los estados seleccionados. Al presionar el ícono de la derecha se seleccionan todos los estados disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoiceShippingMethod"
              v-model="input.CRMWhatsappInvoiceShippingMethod"
              v-model:search="input.CRMWhatsappInvoiceShippingMethodSearch"
              :items="display.CRMWhatsappInvoiceShippingMethod"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceShippingMethodSearch = null; input.CRMWhatsappInvoiceShippingMethod.length = 0; input.allCRMWhatsappInvoiceShippingMethodSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingMethod');"
              @update:model-value="input.allCRMWhatsappInvoiceShippingMethodSelected = input.CRMWhatsappInvoiceShippingMethod.length == display.CRMWhatsappInvoiceShippingMethod.filter(state => state != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoiceShippingMethod.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingMethod') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoiceShippingMethodSearch && /\S/.test(input.CRMWhatsappInvoiceShippingMethodSearch)) || input.CRMWhatsappInvoiceShippingMethod.length > 0 ? 'mdi-source-branch-remove' : 'mdi-source-branch'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por método de entrega"
              placeholder="Todos los métodos de entrega"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoiceShippingMethodSelected" 
                  @update:model-value="input.CRMWhatsappInvoiceShippingMethod = input.allCRMWhatsappInvoiceShippingMethodSelected ? display.CRMWhatsappInvoiceShippingMethod.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoiceShippingMethod = input.CRMWhatsappInvoiceShippingMethod.filter(state => state != item.value); input.allCRMWhatsappInvoiceShippingMethodSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoiceShippingMethod.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceShippingMethod') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoiceShippingMethod.length - 2 }} {{ input.CRMWhatsappInvoiceShippingMethod.length - 2 == 1 ? 'método de entrega' : 'métodos de entrega' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El método de entrega de la orden. Si se coloca al menos un método de entrega, se buscarán todas las ordenes con el o los métodos de entrega seleccionados. Al presionar el ícono de la izquierda se limpiará el o los métodos de entrega seleccionados. Al presionar el ícono de la derecha se seleccionan todos los métodos de entrega disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoicePaymentMethod"
              v-model="input.CRMWhatsappInvoicePaymentMethod"
              v-model:search="input.CRMWhatsappInvoicePaymentMethodSearch"
              :items="display.CRMWhatsappInvoicePaymentMethod"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoicePaymentMethodSearch = null; input.CRMWhatsappInvoicePaymentMethod.length = 0; input.allCRMWhatsappInvoicePaymentMethodSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentMethod');"
              @update:model-value="input.allCRMWhatsappInvoicePaymentMethodSelected = input.CRMWhatsappInvoicePaymentMethod.length == display.CRMWhatsappInvoicePaymentMethod.filter(state => state != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoicePaymentMethod.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentMethod') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoicePaymentMethodSearch && /\S/.test(input.CRMWhatsappInvoicePaymentMethodSearch)) || input.CRMWhatsappInvoicePaymentMethod.length > 0 ? 'mdi-cash-off' : 'mdi-cash'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por método de pago"
              placeholder="Todos los métodos de pago"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoicePaymentMethodSelected" 
                  @update:model-value="input.CRMWhatsappInvoicePaymentMethod = input.allCRMWhatsappInvoicePaymentMethodSelected ? display.CRMWhatsappInvoicePaymentMethod.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoicePaymentMethod = input.CRMWhatsappInvoicePaymentMethod.filter(state => state != item.value); input.allCRMWhatsappInvoicePaymentMethodSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoicePaymentMethod.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentMethod') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoicePaymentMethod.length - 2 }} {{ input.CRMWhatsappInvoicePaymentMethod.length - 2 == 1 ? 'método de pago' : 'métodos de pago' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El método de pago de la orden. Si se coloca al menos un método de pago, se buscarán todas las ordenes con el o los métodos de pago seleccionados. Al presionar el ícono de la izquierda se limpiará el o los métodos de pago seleccionados. Al presionar el ícono de la derecha se seleccionan todos los métodos de pago disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="CRMWhatsappInvoicePaymentState"
              v-model="input.CRMWhatsappInvoicePaymentState"
              v-model:search="input.CRMWhatsappInvoicePaymentStateSearch"
              :items="display.CRMWhatsappInvoicePaymentState"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoicePaymentStateSearch = null; input.CRMWhatsappInvoicePaymentState.length = 0; input.allCRMWhatsappInvoicePaymentStateSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentState');"
              @update:model-value="input.allCRMWhatsappInvoicePaymentStateSelected = input.CRMWhatsappInvoicePaymentState.length == display.CRMWhatsappInvoicePaymentState.filter(state => state != null).length; updateURLSearchQuery(); input.CRMWhatsappInvoicePaymentState.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentState') : null;"
              :prepend-inner-icon="(input.CRMWhatsappInvoicePaymentStateSearch && /\S/.test(input.CRMWhatsappInvoicePaymentStateSearch)) || input.CRMWhatsappInvoicePaymentState.length > 0 ? 'mdi-cash-off' : 'mdi-cash-refund'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por estado de pago"
              placeholder="Todos los estados de pago"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allCRMWhatsappInvoicePaymentStateSelected" 
                  @update:model-value="input.CRMWhatsappInvoicePaymentState = input.allCRMWhatsappInvoicePaymentStateSelected ? display.CRMWhatsappInvoicePaymentState.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.CRMWhatsappInvoicePaymentState = input.CRMWhatsappInvoicePaymentState.filter(state => state != item.value); input.allCRMWhatsappInvoicePaymentStateSelected = false; updateURLSearchQuery(); input.CRMWhatsappInvoicePaymentState.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoicePaymentState') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappInvoicePaymentState.length - 2 }} {{ input.CRMWhatsappInvoicePaymentState.length - 2 == 1 ? 'estado de pago' : 'estados de pago' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El estado de pago de la orden. Si se coloca al menos un estado de pago, se buscarán todas las ordenes con el o los estados de pago seleccionados. Al presionar el ícono de la izquierda se limpiará el o los estados de pago seleccionados. Al presionar el ícono de la derecha se seleccionan todos los estados de pago disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-select 
              v-bind="props"
              ref="CRMWhatsappInvoiceIsBilled"
              v-model="input.CRMWhatsappInvoiceIsBilled"
              :items="display.CRMWhatsappInvoiceIsBilled"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceIsBilled = null; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceIsBilled');"
              @update:model-value="updateURLSearchQuery();"
              :prepend-inner-icon="input.CRMWhatsappInvoiceIsBilled ? 'mdi-invoice-remove' : 'mdi-invoice'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por estado de facturación"
              placeholder="Todos los estados de facturación"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="CRMWhatsappInvoiceIsBilledID"
              item-title="CRMWhatsappInvoiceIsBilledName"
              hide-details
              style="margin-bottom: 15px;"
            >
            </v-select>
          </template>
          <span style="max-width: 400px; display: block;">El estado de facturación de la orden. Si se coloca un estado de facturación, se buscarán todas las ordenes con el estado de facturación seleccionado. Al presionar el ícono de la izquierda se limpiará el estado de facturación seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-textarea 
              v-bind="props"
              ref="CRMWhatsappInvoiceNote"
              v-model="input.CRMWhatsappInvoiceNote"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.CRMWhatsappInvoiceNote = null; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappInvoiceNote');"
              @update:model-value="updateURLSearchQuery();"
              :prepend-inner-icon="input.CRMWhatsappInvoiceNote && /\S/.test(input.CRMWhatsappInvoiceNote) ? 'mdi-note-off' : 'mdi-note'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por nota"
              placeholder="Todas las notas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              rows="2"
              max-rows="4"
              auto-grow
              hide-details
              style="margin-bottom: 30px;"
            >
            </v-textarea>
          </template>
          <span style="max-width: 400px; display: block;">La nota de la orden. Si se coloca una nota, se buscarán todas las ordenes con la nota seleccionada. Al presionar el ícono de la izquierda se limpiará la nota seleccionada</span>
        </v-tooltip>
        <div style="display: flex; align-items: center; margin-bottom: 15px;">
          <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros por producto:</strong></span>
          <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
        </div>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productID"
              v-model="input.productID"
              v-model:search="input.productIDSearch"
              :items="display.product"
              @keydown.enter.prevent="scanProduct()"
              @click:prepend-inner="input.productID = null; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productID');"
              @update:model-value="updateURLSearchQuery();"
              :prepend-inner-icon="(input.productID && /\S/.test(input.productID)) ? 'mdi-close-circle' : 'mdi-package'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por producto"
              placeholder="Todos los productos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productID"
              item-title="productName"
              hide-no-data
              hide-details
              style="margin-bottom: 15px;"
            ></v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">Si se coloca un producto, se buscarán todas las ordenes que incluyan el producto seleccionado. Al presionar el ícono de la izquierda se limpiará el producto seleccionado</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productCategoryID"
              v-model="input.productCategoryID"
              v-model:search="input.productCategoryIDSearch"
              :items="display.productCategory"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productCategoryIDSearch = null; input.productCategoryID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productCategoryID');"
              @update:model-value="input.allProductCategoryIDSelected = input.productCategoryID.length == display.productCategory.filter(state => state != null).length; updateURLSearchQuery(); input.productCategoryID.length == 0 ? $generalFunctions.default.blurInput(this, 'productCategoryID') : null;"
              :prepend-inner-icon="(input.productCategoryIDSearch && /\S/.test(input.productCategoryIDSearch)) || input.productCategoryID.length > 0 ? 'mdi-cog-off' : 'mdi-cog'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por categoría "
              placeholder="Todas las categorías"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productCategoryID"
              item-title="productCategoryName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductCategoryIDSelected" 
                  @update:model-value="input.productCategoryID = input.allProductCategoryIDSelected ? display.productCategory.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productCategoryID = input.productCategoryID.filter(state => state != item.value); input.allProductCategoryIDSelected = false; updateURLSearchQuery(); input.productCategoryID.length == 0 ? $generalFunctions.default.blurInput(this, 'productCategoryID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productCategoryID.length - 2 }} {{ input.productCategoryID.length - 2 == 1 ? 'categoría de producto' : 'categorías de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La categoría del producto. Si se coloca al menos una categoría de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las categorías de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará la o las categorías de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las categorías de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productBrandID"
              v-model="input.productBrandID"
              v-model:search="input.productBrandIDSearch"
              :items="display.productBrand"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productBrandIDSearch = null; input.productBrandID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productBrandID');"
              @update:model-value="input.allProductBrandIDSelected = input.productBrandID.length == display.productBrand.filter(state => state != null).length; updateURLSearchQuery(); input.productBrandID.length == 0 ? $generalFunctions.default.blurInput(this, 'productBrandID') : null;"
              :prepend-inner-icon="(input.productBrandIDSearch && /\S/.test(input.productBrandIDSearch)) || input.productBrandID.length > 0 ? 'mdi-archive-off' : 'mdi-archive'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por marca"
              placeholder="Todas las marcas"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productBrandID"
              item-title="productBrandName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductBrandIDSelected" 
                  @update:model-value="input.productBrandID = input.allProductBrandIDSelected ? display.productBrand.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productBrandID = input.productBrandID.filter(state => state != item.value); input.allProductBrandIDSelected = false; updateURLSearchQuery(); input.productBrandID.length == 0 ? $generalFunctions.default.blurInput(this, 'productBrandID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productBrandID.length - 2 }} {{ input.productBrandID.length - 2 == 1 ? 'marca de producto' : 'marcas de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La marca del producto. Si se coloca al menos una marca de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las marcas de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará la o las marcas de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las marcas de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productModelID"
              v-model="input.productModelID"
              v-model:search="input.productModelIDSearch"
              :items="display.productModel"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productModelIDSearch = null; input.productModelID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productModelID');"
              @update:model-value="input.allProductModelIDSelected = input.productModelID.length == display.productModel.filter(state => state != null).length; updateURLSearchQuery(); input.productModelID.length == 0 ? $generalFunctions.default.blurInput(this, 'productModelID') : null;"
              :prepend-inner-icon="(input.productModelIDSearch && /\S/.test(input.productModelIDSearch)) || input.productModelID.length > 0 ? 'mdi-checkbox-blank-off' : 'mdi-checkbox-blank'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por modelo"
              placeholder="Todas los modelos"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productModelID"
              item-title="productModelName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductModelIDSelected" 
                  @update:model-value="input.productModelID = input.allProductModelIDSelected ? display.productModel.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productModelID = input.productModelID.filter(state => state != item.value); input.allProductModelIDSelected = false; updateURLSearchQuery(); input.productModelID.length == 0 ? $generalFunctions.default.blurInput(this, 'productModelID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productModelID.length - 2 }} {{ input.productModelID.length - 2 == 1 ? 'modelo de producto' : 'modelos de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">La modelo del producto. Si se coloca al menos una modelo de producto, se buscarán todas las ordenes que incluyan al menos un producto con la o las modelos de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará la o las modelos de producto seleccionadas. Al presionar el ícono de la derecha se seleccionan todas las modelos de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productFlavorID"
              v-model="input.productFlavorID"
              v-model:search="input.productFlavorIDSearch"
              :items="display.productFlavor"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productFlavorIDSearch = null; input.productFlavorID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productFlavorID');"
              @update:model-value="input.allProductFlavorIDSelected = input.productFlavorID.length == display.productFlavor.filter(state => state != null).length; updateURLSearchQuery(); input.productFlavorID.length == 0 ? $generalFunctions.default.blurInput(this, 'productFlavorID') : null;"
              :prepend-inner-icon="(input.productFlavorIDSearch && /\S/.test(input.productFlavorIDSearch)) || input.productFlavorID.length > 0 ? 'mdi-water-off' : 'mdi-water'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por sabor"
              placeholder="Todos los sabores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productFlavorID"
              item-title="productFlavorName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductFlavorIDSelected" 
                  @update:model-value="input.productFlavorID = input.allProductFlavorIDSelected ? display.productFlavor.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productFlavorID = input.productFlavorID.filter(state => state != item.value); input.allProductFlavorIDSelected = false; updateURLSearchQuery(); input.productFlavorID.length == 0 ? $generalFunctions.default.blurInput(this, 'productFlavorID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productFlavorID.length - 2 }} {{ input.productFlavorID.length - 2 == 1 ? 'sabor de producto' : 'sabores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El sabor del producto. Si se coloca al menos una sabor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los sabores de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará el o los sabores de producto seleccionados. Al presionar el ícono de la derecha se seleccionan todos los sabores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productNicotineLevelID"
              v-model="input.productNicotineLevelID"
              v-model:search="input.productNicotineLevelIDSearch"
              :items="display.productNicotineLevel"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productNicotineLevelIDSearch = null; input.productNicotineLevelID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productNicotineLevelID');"
              @update:model-value="input.allProductNicotineLevelIDSelected = input.productNicotineLevelID.length == display.productNicotineLevel.filter(state => state != null).length; updateURLSearchQuery(); input.productNicotineLevelID.length == 0 ? $generalFunctions.default.blurInput(this, 'productNicotineLevelID') : null;"
              :prepend-inner-icon="(input.productNicotineLevelIDSearch && /\S/.test(input.productNicotineLevelIDSearch)) || input.productNicotineLevelID.length > 0 ? 'mdi-cloud-off' : 'mdi-cloud'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por nivel de nicotina"
              placeholder="Todos los niveles de nicotina"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productNicotineLevelID"
              item-title="productNicotineLevelName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductNicotineLevelIDSelected" 
                  @update:model-value="input.productNicotineLevelID = input.allProductNicotineLevelIDSelected ? display.productNicotineLevel.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productNicotineLevelID = input.productNicotineLevelID.filter(state => state != item.value); input.allProductNicotineLevelIDSelected = false; updateURLSearchQuery(); input.productNicotineLevelID.length == 0 ? $generalFunctions.default.blurInput(this, 'productNicotineLevelID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productNicotineLevelID.length - 2 }} {{ input.productNicotineLevelID.length - 2 == 1 ? 'nivel de nicotina de producto' : 'niveles de nicotina de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará el o los niveles de nicotina de producto seleccionados. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productSizeID"
              v-model="input.productSizeID"
              v-model:search="input.productSizeIDSearch"
              :items="display.productSize"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productSizeIDSearch = null; input.productSizeID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productSizeID');"
              @update:model-value="input.allProductSizeIDSelected = input.productSizeID.length == display.productSize.filter(state => state != null).length; updateURLSearchQuery(); input.productSizeID.length == 0 ? $generalFunctions.default.blurInput(this, 'productSizeID') : null;"
              :prepend-inner-icon="(input.productSizeIDSearch && /\S/.test(input.productSizeIDSearch)) || input.productSizeID.length > 0 ? 'mdi-signal-off' : 'mdi-signal'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por tamaño"
              placeholder="Todos los tamaños"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productSizeID"
              item-title="productSizeName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductSizeIDSelected" 
                  @update:model-value="input.productSizeID = input.allProductSizeIDSelected ? display.productSize.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productSizeID = input.productSizeID.filter(state => state != item.value); input.allProductSizeIDSelected = false; updateURLSearchQuery(); input.productSizeID.length == 0 ? $generalFunctions.default.blurInput(this, 'productSizeID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productSizeID.length - 2 }} {{ input.productSizeID.length - 2 == 1 ? 'tamaño de producto' : 'tamaños de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El nivel de nicotina del producto. Si se coloca al menos una nivel de nicotina de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los niveles de nicotina de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará el o los niveles de nicotina de producto seleccionados. Al presionar el ícono de la derecha se seleccionan todos los niveles de nicotina de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productProviderID"
              v-model="input.productProviderID"
              v-model:search="input.productProviderIDSearch"
              :items="display.productProvider"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productProviderIDSearch = null; input.productProviderID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productProviderID');"
              @update:model-value="input.allProductProviderIDSelected = input.productProviderID.length == display.productProvider.filter(state => state != null).length; updateURLSearchQuery(); input.productProviderID.length == 0 ? $generalFunctions.default.blurInput(this, 'productProviderID') : null;"
              :prepend-inner-icon="(input.productProviderIDSearch && /\S/.test(input.productProviderIDSearch)) || input.productProviderID.length > 0 ? 'mdi-briefcase-off' : 'mdi-briefcase'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por proveedor"
              placeholder="Todos los proveedores"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productProviderID"
              item-title="productProviderName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductProviderIDSelected" 
                  @update:model-value="input.productProviderID = input.allProductProviderIDSelected ? display.productProvider.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productProviderID = input.productProviderID.filter(state => state != item.value); input.allProductProviderIDSelected = false; updateURLSearchQuery(); input.productProviderID.length == 0 ? $generalFunctions.default.blurInput(this, 'productProviderID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productProviderID.length - 2 }} {{ input.productProviderID.length - 2 == 1 ? 'proveedor de producto' : 'proveedores de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El proveedor del producto. Si se coloca al menos una proveedor de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los proveedores de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará el o los proveedores de producto seleccionados. Al presionar el ícono de la derecha se seleccionan todos los proveedores de producto disponibles</span>
        </v-tooltip>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
          <template v-slot:activator="{ props }">
            <v-autocomplete 
              v-bind="props"
              ref="productTagID"
              v-model="input.productTagID"
              v-model:search="input.productTagIDSearch"
              :items="display.productTag"
              @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
              @click:prepend-inner="input.productTagIDSearch = null; input.productTagID.length = 0; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'productTagID');"
              @update:model-value="input.allProductTagIDSelected = input.productTagID.length == display.productTag.filter(state => state != null).length; updateURLSearchQuery(); input.productTagID.length == 0 ? $generalFunctions.default.blurInput(this, 'productTagID') : null;"
              :prepend-inner-icon="(input.productTagIDSearch && /\S/.test(input.productTagIDSearch)) || input.productTagID.length > 0 ? 'mdi-tag-off' : 'mdi-tag'" 
              :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
              label="Filtrar por tag"
              placeholder="Todos los tags"
              variant="outlined" 
              density="compact"
              autocomplete="off"
              item-value="productTagID"
              item-title="productTagName"
              hide-no-data
              multiple
              chips
              closable-chips
              hide-details
            >
              <template v-slot:append="{ props }">
                <v-checkbox-btn 
                  v-bind="props"
                  v-model="input.allProductTagIDSelected" 
                  @update:model-value="input.productTagID = input.allProductTagIDSelected ? display.productTag.filter(state => state != null).map(state => state) : []; updateURLSearchQuery()"
                  color="primary" 
                  density="compact" 
                  hide-details
                  class="hoverableVButton"
                ></v-checkbox-btn>
              </template>
              <template v-slot:chip="{ item, index }">
                <v-chip v-if="index < 2" variant="flat" label>
                  <p>{{ item.title }}</p>
                  <template v-slot:close>
                    <v-icon @click.stop="input.productTagID = input.productTagID.filter(state => state != item.value); input.allProductTagIDSelected = false; updateURLSearchQuery(); input.productTagID.length == 0 ? $generalFunctions.default.blurInput(this, 'productTagID') : null;">mdi-close-circle</v-icon>
                  </template>
                </v-chip>
                <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.productTagID.length - 2 }} {{ input.productTagID.length - 2 == 1 ? 'tag de producto' : 'tags de producto' }})</p>
              </template>
            </v-autocomplete>
          </template>
          <span style="max-width: 400px; display: block;">El tag del producto. Si se coloca al menos una tag de producto, se buscarán todas las ordenes que incluyan al menos un producto con el o los tags de producto seleccionadas. Al presionar el ícono de la izquierda se limpiará el o los tags de producto seleccionados. Al presionar el ícono de la derecha se seleccionan todos los tags de producto disponibles</span>
        </v-tooltip>
        <template v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMWhatsappConversation')?.CRMAgentPermissionValue == '1'">
          <div style="display: flex; align-items: center; margin-bottom: 15px; margin-top: 30px;">
            <span style="white-space: nowrap; margin-right: 10px; font-size: large;"><strong>Filtros por conversación:</strong></span>
            <v-divider color="indigo" thickness="2" class="border-opacity-100" style="flex: 1 1 auto;"></v-divider>
          </div>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-text-field 
                v-bind="props"
                ref="CRMWhatsappConversationID"
                v-model="input.CRMWhatsappConversationID"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
                @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappConversationID'); input.CRMWhatsappConversationID = null;" 
                :prepend-inner-icon="input.CRMWhatsappConversationID && /\S/.test(input.CRMWhatsappConversationID) ? 'mdi-barcode-off' : 'mdi-barcode'"
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                type="number"
                label="Buscar por identificador interno"
                variant="outlined" 
                density="compact"
                autocomplete="off"
                hide-details
                hide-spin-buttons
                style="margin-bottom: 15px;"
              >
              </v-text-field>
            </template>
            <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único que se asigna de forma automática a la conversación. Si se coloca un identificador interno, se buscará la única conversación que coincida con el mismo, ignorando el resto de filtros seleccionados. Al presionar el ícono de la izquierda se limpiará el identificador interno colocado</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-date-input
                v-bind="props"
                ref="CRMWhatsappConversationStartDatetime"
                v-model="input.CRMWhatsappConversationStartDatetime"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappConversationStartDatetime'); input.CRMWhatsappConversationStartDatetime.length = 0;" 
                :prepend-inner-icon="input.CRMWhatsappConversationStartDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                prepend-icon=""
                label="Filtrar por fecha de inicio"
                variant="outlined"
                density="compact"
                multiple="range"
                autocomplete="off"
                hide-details
                style="margin-bottom: 15px;"
              ></v-date-input>
            </template>
            <span style="max-width: 400px; display: block;">El filtro por fecha de inicio de la conversación permite buscar todas las conversaciones que hayan iniciado en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de inicio de la conversación colocada</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-date-input
                v-bind="props"
                ref="CRMWhatsappConversationEndDatetime"
                v-model="input.CRMWhatsappConversationEndDatetime"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @click:prepend-inner.stop="$generalFunctions.default.blurInput(this, 'CRMWhatsappConversationEndDatetime'); input.CRMWhatsappConversationEndDatetime.length = 0;" 
                :prepend-inner-icon="input.CRMWhatsappConversationEndDatetime.length > 0 ? 'mdi-calendar-remove' : 'mdi-calendar'"
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                prepend-icon=""
                label="Filtrar por fecha de finalización"
                variant="outlined"
                density="compact"
                multiple="range"
                autocomplete="off"
                hide-details
                style="margin-bottom: 15px;"
              ></v-date-input>
            </template>
            <span style="max-width: 400px; display: block;">El filtro por fecha de finalización de la conversación permite buscar todas las conversaciones que hayan finalizado en una fecha específica. Al presionar el ícono de la izquierda se limpia el filtro de fecha de finalización de la conversación colocada</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-autocomplete 
                v-bind="props"
                ref="CRMWhatsappConversationCRMAgentID"
                v-model="input.CRMWhatsappConversationCRMAgentID"
                v-model:search="input.CRMWhatsappConversationCRMAgentIDSearch"
                :items="systemInformationData.CRMAgents"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @click:prepend-inner="input.CRMWhatsappConversationCRMAgentIDSearch = null; input.CRMWhatsappConversationCRMAgentID.length = 0; input.allCRMWhatsappConversationCRMAgentIDSelected = false; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappConversationCRMAgentID');"
                @update:model-value="input.allCRMWhatsappConversationCRMAgentIDSelected = input.CRMWhatsappConversationCRMAgentID.length == systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).length; updateURLSearchQuery(); input.CRMWhatsappConversationCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappConversationCRMAgentID') : null;"
                :prepend-inner-icon="(input.CRMWhatsappConversationCRMAgentIDSearch && /\S/.test(input.CRMWhatsappConversationCRMAgentIDSearch)) || input.CRMWhatsappConversationCRMAgentID.length > 0 ? 'mdi-briefcase-off' : 'mdi-briefcase-account'" 
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                item-title="CRMAgentName"
                item-value="CRMAgentID"
                label="Filtrar por agente involucrado"
                placeholder="Todos los agentes involucrados"
                variant="outlined" 
                density="compact"
                autocomplete="off"
                hide-no-data
                multiple
                chips
                closable-chips
                hide-details
                style="margin-bottom: 15px;"
              >
                <template v-slot:append="{ props }">
                  <v-checkbox-btn 
                    v-bind="props"
                    v-model="input.allCRMWhatsappConversationCRMAgentIDSelected" 
                    @update:model-value="input.CRMWhatsappConversationCRMAgentID = input.allCRMWhatsappConversationCRMAgentIDSelected ? systemInformationData.CRMAgents.filter(CRMAgent => CRMAgent.CRMAgentID != null).map(CRMAgent => CRMAgent.CRMAgentID) : []; updateURLSearchQuery()"
                    color="primary" 
                    density="compact" 
                    hide-details
                    class="hoverableVButton"
                  ></v-checkbox-btn>
                </template>
                <template v-slot:chip="{ item, index }">
                  <v-chip v-if="index < 2" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentColor : 'primary'" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.value).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ item.title }}</p>
                    </div>
                    <template v-slot:close>
                      <v-icon @click.stop="input.CRMWhatsappConversationCRMAgentID = input.CRMWhatsappConversationCRMAgentID.filter(CRMAgentID => CRMAgentID != item.value); input.allCRMWhatsappConversationCRMAgentIDSelected = false; updateURLSearchQuery(); input.CRMWhatsappConversationCRMAgentID.length == 0 ? $generalFunctions.default.blurInput(this, 'CRMWhatsappConversationCRMAgentID') : null;">mdi-close-circle</v-icon>
                    </template>
                  </v-chip>
                  <p v-if="index == 2" style="color: #9e9e9e; font-size: small;">(+{{ input.CRMWhatsappConversationCRMAgentID.length - 2 }} agente{{ input.CRMWhatsappConversationCRMAgentID.length - 2 == 1 ? '' : 's' }})</p>
                </template>
              </v-autocomplete>
            </template>
            <span style="max-width: 400px; display: block;">El agente involucrado en la conversación. Si se coloca al menos un agente involucrado, se buscarán todas las conversaciones que tengan involucrado al o los agentes seleccionados. Al presionar el ícono de la izquierda se limpiará el o los agentes involucrados seleccionados. Al presionar el ícono de la derecha se seleccionan todos los agentes involucrados disponibles</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-textarea 
                v-bind="props"
                ref="CRMWhatsappConversationNoteOrCRMWhatsappMessageNote"
                v-model="input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @click:prepend-inner="input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote = null; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappConversationNoteOrCRMWhatsappMessageNote');"
                @update:model-value="updateURLSearchQuery();"
                :prepend-inner-icon="input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote && /\S/.test(input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote) ? 'mdi-note-off' : 'mdi-note'" 
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                label="Filtrar por nota"
                placeholder="Todas las notas"
                variant="outlined" 
                density="compact"
                autocomplete="off"
                rows="2"
                max-rows="4"
                auto-grow
                hide-details
                style="margin-bottom: 15px;"
              >
              </v-textarea>
            </template>
            <span style="max-width: 400px; display: block;">La nota de la conversación o nota del mensaje. Si se coloca una nota, se buscarán todas las conversaciones con la nota seleccionada. Al presionar el ícono de la izquierda se limpiará la nota seleccionada</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-textarea 
                v-bind="props"
                ref="CRMWhatsappMessageContent"
                v-model="input.CRMWhatsappMessageContent"
                @keydown.enter.prevent="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
                @click:prepend-inner="input.CRMWhatsappMessageContent = null; updateURLSearchQuery(); $generalFunctions.default.blurInput(this, 'CRMWhatsappMessageContent');"
                @update:model-value="updateURLSearchQuery();"
                :prepend-inner-icon="input.CRMWhatsappMessageContent && /\S/.test(input.CRMWhatsappMessageContent) ? 'mdi-message-off' : 'mdi-message'" 
                :loading="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
                label="Filtrar por contenido del mensaje"
                placeholder="Todos los contenidos del mensaje"
                variant="outlined" 
                density="compact"
                autocomplete="off"
                rows="2"
                max-rows="4"
                auto-grow
                hide-details
              >
              </v-textarea>
            </template>
            <span style="max-width: 400px; display: block;">El contenido de un mensaje que forma parte de la conversación. Si se coloca un contenido del mensaje, se buscarán todas las conversaciones que contengan un mensaje con un contenido que coincida total o parcialmente con el contenido del mensaje colocado. Al presionar el ícono de la izquierda se limpiará el contenido del mensaje colocado</span>
          </v-tooltip>
        </template>
      </div>
      <v-card elevation="0" rounded="0" color="indigo" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="width: 100%; height: 120px; padding: 15px; overflow: hidden; align-items: center; justify-content: center;">
        <v-btn 
          @click="selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true)"
          :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" 
          block
          color="indigo"
          class="hoverableVButton"
        >
          <v-icon size="large" color="white" style="margin-right: 10px;">mdi-magnify</v-icon>
          <h3 style="color: white;">BUSCAR</h3>
        </v-btn>
        <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="1000" location="top">
          <template v-slot:activator="{ props }">
            <v-btn 
              v-bind="props" 
              @click="setDefaultValues()"
              :disabled="loader.getSystemInformation || loader.selectCRMShippingAgent || loader.selectProductSearchParameters || loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView" 
              block
              color="secondary"
              style="margin-top: 15px;"
              class="hoverableVButton"
            >
              <v-icon size="large" color="white" style="margin-right: 10px;">mdi-backspace</v-icon>
              <h3 style="color: white;">LIMPIAR</h3>
            </v-btn>
          </template>
          <span style="width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
        </v-tooltip>
      </v-card>
    </v-card>
    <div class="contentContainer">
      <v-data-table 
        :headers="display.CRMWhatsappInvoiceHeaders"
        :items="display.CRMWhatsappInvoice" 
        :loading="loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView"
        :items-per-page="-1"
        no-data-text=""
        fixed-header
        hover
        style="flex: 1; overflow-y: auto;"
      >
        <template v-slot:headers="{ columns }">
          <tr>
            <th v-for="column in columns" :key="column.key">
              <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 25px;">
                <template v-if="display.CRMWhatsappInvoice.length > 0">
                  <v-icon v-if="navigation.searchVisible == false && display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).index == 0" @click="navigation.searchVisible = true" size="large" style="margin-right: 10px;">mdi-arrow-right-bottom-bold</v-icon>
                  <v-icon v-if="display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).index > 0" @click="updateTableHeaderIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                  <v-icon v-if="display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).icon" color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).icon }}</v-icon>
                  <span v-if="navigation.tableVisibility[column.key] && display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).title" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).title }}</strong></span>
                  <v-icon @click="navigation.tableVisibility[column.key] = !navigation.tableVisibility[column.key]; updateTableVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ navigation.tableVisibility[column.key] ? 'eye' : 'eye-off' }}</v-icon>
                  <v-icon v-if="display.CRMWhatsappInvoiceHeaders.find(header => header.value == column.key).index < display.CRMWhatsappInvoiceHeaders.length - 1" @click="updateTableHeaderIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>
                </template>
              </v-card>
              <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
            </th>
          </tr>
        </template>
        <template v-slot:item="row">
          <tr>
            <template v-for="header in display.CRMWhatsappInvoiceHeaders.sort((a, b) => a.index - b.index)" :key="header.value">
              <td>
                <template v-if="header.value == 'CRMWhatsappInvoiceIsBilled' && navigation.tableVisibility[header.value]">
                 <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Orden facturada" location="top">
                  <template v-slot:activator="{ props }">
                    <v-icon 
                      v-bind="props"
                      :color="row.item.CRMWhatsappInvoiceIsBilled == 1 ? 'indigo' : 'grey'" 
                      :size="row.item.CRMWhatsappInvoiceIsBilled == 1 ? 'small' : 'x-small'"
                      :class="{'pulseSmallElement': row.item.CRMWhatsappInvoiceIsBilled == 1}"
                    >
                      mdi-circle
                    </v-icon>
                  </template>
                 </v-tooltip>
                </template>
                <template v-if="header.value == 'CRMWhatsappInvoiceID' && navigation.tableVisibility[header.value]">
                  <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                    <template v-slot:activator="{ props }">
                      <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, `ID de la orden`, 'o', row.item.CRMWhatsappInvoiceID)" class="hoverableText" style="color: #3F51B5; user-select: none;"><strong>{{ row.item.CRMWhatsappInvoiceID }}</strong></p>
                    </template>
                  </v-tooltip>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappContactID' && navigation.tableVisibility[header.value]">
                  <div style="white-space: nowrap;">
                    <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                    <p style="font-size: small; color: #9e9e9e; margin: 0;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                  </div>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceState' && navigation.tableVisibility[header.value]">
                  <div style="display: flex; align-items: center; gap: 10px;">
                    <v-chip :color="{'Orden generada': 'error', 'Orden en localidad': 'warning', 'Orden en entrega': 'teal', 'Orden entregada': 'success', 'Orden no entregada': 'gray', 'Orden cancelada': 'error'}[row.item.CRMWhatsappInvoiceState]" variant="flat" label>
                      <p>{{ row.item.CRMWhatsappInvoiceState }}</p>
                    </v-chip>
                    <v-menu 
                      v-model="navigation.updateCRMWhatsappInvoiceMenuIsVisible[row.item.CRMWhatsappInvoiceID]"
                      @update:model-value="input.updatedCRMWhatsappInvoiceState = null"
                      :close-on-content-click="false" 
                      location="bottom"
                      scrim
                    >
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" :color="{'Orden generada': 'error', 'Orden en localidad': 'warning', 'Orden en entrega': 'teal', 'Orden entregada': 'success', 'Orden no entregada': 'gray', 'Orden cancelada': 'error'}[row.item.CRMWhatsappInvoiceState]">mdi-pencil</v-icon>
                      </template>
                      <v-card width="600px" rounded="0" elevation="0">
                        <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">  
                          <v-icon color="indigo" size="x-large">mdi-timeline</v-icon>
                          <h2>Estado de la orden</h2>
                        </v-card>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                        <div style="padding: 15px;">
                          <v-select
                            v-model="input.updatedCRMWhatsappInvoiceState"
                            :items="['Orden en localidad', 'Orden no entregada']"
                            label="Estado de la orden"
                            variant="outlined"
                            density="compact"
                            autocomplete="off"
                            hide-details
                          ></v-select>
                        </div>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                        <v-card color="primary" rounded="0" elevation="0" style="display: flex; flex-direction: column; padding: 15px; gap: 10px;">
                          <v-btn 
                            @click="updateCRMWhatsappInvoiceState(row.item)"
                            block
                            color="indigo"
                            class="hoverableVButton"
                          >
                            <v-icon size="large" color="white" style="margin-right: 10px;">mdi-update</v-icon>
                            <h3 style="color: white;">ACTUALIZAR</h3>
                          </v-btn>
                          <v-btn 
                            @click="navigation.updateCRMWhatsappInvoiceMenuIsVisible[row.item.CRMWhatsappInvoiceID] = false"
                            block
                            color="error"
                            class="hoverableVButton"
                          >
                            <v-icon size="large" color="white" style="margin-right: 10px;">mdi-close-circle</v-icon>
                            <h3 style="color: white;">CERRAR</h3>
                          </v-btn>
                        </v-card>
                      </v-card>
                    </v-menu>
                  </div>

                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceTime' && navigation.tableVisibility[header.value]">
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <v-menu :close-on-content-click="false" scrim location="bottom">
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-chip :disabled="row.item.CRMWhatsappInvoiceState != 'Orden generada'" color="error" variant="flat" size="small" label>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.getDatetimeDifferenceToHHMMSS(row.item.CRMWhatsappInvoiceCRMStartDatetime, row.item.CRMWhatsappInvoiceCRMEndDatetime) }}</p>
                          </v-chip>
                        </div>
                      </template>
                      <v-card rounded="0" elevation="0">
                        <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">
                          <v-icon color="indigo" size="x-large">mdi-clock</v-icon>
                          <h2>Tiempo de gestión</h2>
                        </v-card>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                        <div style="padding: 10px;">
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-one</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Generación: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceCreationDatetime) }}</p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-two</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Entrada al gestor de órdenes: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceCRMStartDatetime) }}</p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-three</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Salida del gestor de órdenes: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceCRMEndDatetime) }}</p>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <v-menu :close-on-content-click="false" scrim location="bottom">
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-chip :disabled="row.item.CRMWhatsappInvoiceState != 'Orden en localidad'" color="warning" variant="flat" size="small" label>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.getDatetimeDifferenceToHHMMSS(row.item.CRMWhatsappInvoiceLocalityStartDatetime, row.item.CRMWhatsappInvoiceLocalityEndDatetime) }}</p>
                          </v-chip>
                        </div>
                      </template>
                      <v-card rounded="0" elevation="0">
                        <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">
                          <v-icon color="indigo" size="x-large">mdi-clock</v-icon>
                          <h2>Tiempo de localidad</h2>
                        </v-card>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                        <div style="padding: 10px;">
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-one</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Llegada a localidad: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceLocalityStartDatetime) }}</p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-two</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Salida de localidad: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceLocalityEndDatetime) }}</p>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                    <v-menu :close-on-content-click="false" scrim location="bottom">
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-chip :disabled="row.item.CRMWhatsappInvoiceState != 'Orden en entrega'" color="teal" variant="flat" size="small" label>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.getDatetimeDifferenceToHHMMSS(row.item.CRMWhatsappInvoiceShippingStartDatetime, row.item.CRMWhatsappInvoiceShippingEndDatetime) }}</p>
                          </v-chip>
                        </div>
                      </template>
                      <v-card rounded="0" elevation="0">
                        <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">
                          <v-icon color="indigo" size="x-large">mdi-clock</v-icon>
                          <h2>Tiempo de entrega</h2>
                        </v-card>
                        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                        <div style="padding: 10px;">
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-one</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Inicio de entrega: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceShippingStartDatetime) }}</p>
                          </div>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon color="indigo" size="small">mdi-clock-time-two</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Fin de entrega: </strong></span>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappInvoiceShippingEndDatetime) }}</p>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                  </div>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceCRMLocalityID' && navigation.tableVisibility[header.value]">
                  <v-chip :color="systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityColor : 'primary'" variant="flat" label>
                    <p>{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID) ? systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID).CRMLocalityName : 'No registrada' }}</p>
                    <div v-if="row.item.CRMWhatsappInvoiceCRMLocalityMapDivisionID" style="display: flex; align-items: center;">
                      <v-icon size="small" style="margin: 0px 5px;">mdi-arrow-right-bold</v-icon>
                      <p style="font-size: small;">{{ systemInformationData.CRMLocalities.find(CRMLocality => CRMLocality.CRMLocalityID == row.item.CRMWhatsappInvoiceCRMLocalityID)?.CRMLocalityMap?.CRMLocalityMapDivisions?.find(CRMLocalityMapDivision => CRMLocalityMapDivision.CRMLocalityMapDivisionID == row.item.CRMWhatsappInvoiceCRMLocalityMapDivisionID)?.CRMLocalityMapDivisionName || 'No registrada' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceCreationCRMAgentID' && navigation.tableVisibility[header.value]">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentColor : 'primary'" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceCreationCRMAgentID).CRMAgentName : 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceAmount' && navigation.tableVisibility[header.value]">
                  <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceAmount || 0) / 5) * 5) }}</p>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoicePaymentMethod' && navigation.tableVisibility[header.value]">
                  <v-menu v-if="row.item.CRMWhatsappInvoicePaymentMethod == 'Pago mixto'" :close-on-content-click="false" location="bottom" scrim>
                    <template v-slot:activator="{ props }">
                      <div v-bind="props" style="white-space: nowrap; display: flex; align-items: center; gap: 10px;" :style="row.item.CRMWhatsappInvoicePaymentMethod == 'Pago mixto' ? 'cursor: pointer;' : null">
                        <div>
                          <p><span style="color: #3F51B5;"><strong>Método: </strong></span>{{ row.item.CRMWhatsappInvoicePaymentMethod }}</p>
                          <p><span style="color: #3F51B5;"><strong>Estado: </strong></span>{{ row.item.CRMWhatsappInvoicePaymentState }}</p>
                        </div>
                        <v-icon size="small" color="indigo">mdi-information</v-icon>
                      </div>
                    </template>
                    <v-card width="600px" style="cursor: default; user-select: none;">
                      <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">
                        <v-icon color="indigo" size="x-large">mdi-cash</v-icon>
                        <h2>Pago mixto</h2>
                      </v-card>
                      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                      <div style="padding: 10px;">
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo" size="small">mdi-cash</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Efectivo: </strong></span>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceMixedPaymentCashAmount || 0) / 5) * 5) }}</p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo" size="small">mdi-credit-card</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Tarjeta: </strong></span>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceMixedPaymentCardAmount || 0) / 5) * 5) }}</p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo" size="small">mdi-cellphone</v-icon>
                          <p><span style="color: #3F51B5;"><strong>SINPE: </strong></span>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceMixedPaymentSINPEAmount || 0) / 5) * 5) }}</p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo" size="small">mdi-bank</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Transferencia: </strong></span>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceMixedPaymentDepositAmount || 0) / 5) * 5) }}</p>
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon color="indigo" size="small">mdi-web</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Plataforma digital: </strong></span>₡ {{ $displayFunctions.default.parseAmountToDisplay(Math.round((row.item.CRMWhatsappInvoiceMixedPaymentWebpageAmount || 0) / 5) * 5) }}</p>
                        </div>
                      </div>
                    </v-card>
                  </v-menu>
                  <div v-else style="white-space: nowrap;">
                    <p><span style="color: #3F51B5;"><strong>Método: </strong></span>{{ row.item.CRMWhatsappInvoicePaymentMethod }}</p>
                    <p><span style="color: #3F51B5;"><strong>Estado: </strong></span>{{ row.item.CRMWhatsappInvoicePaymentState }}</p>
                  </div>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceShippingMethod' && navigation.tableVisibility[header.value]">
                  <v-menu v-if="!['Retiro en localidad', 'Envío mediante Uber Flash'].includes(row.item.CRMWhatsappInvoiceShippingMethod)" :close-on-content-click="false" location="bottom" scrim>
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="primary" variant="flat" style="margin: 5px 0px;">
                        <v-icon size="small" style="margin-right: 10px;">mdi-map-marker</v-icon>
                        <p style="font-size: small;">VER ENTREGA</p>
                      </v-btn>
                    </template>
                    <v-card width="600px" style="cursor: default; user-select: none;">
                      <v-card color="primary" rounded="0" elevation="0" style="padding: 15px; display: flex; align-items: center; gap: 10px;">
                        <v-icon color="indigo" size="x-large">mdi-map-marker</v-icon>
                        <h2>Datos de entrega</h2>
                      </v-card>
                      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
                      <div style="padding: 15px; display: flex; flex-direction: column; gap: 10px;">
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-note</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Nota: </strong></span>{{ row.item.CRMWhatsappInvoiceNote }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-clock</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Fecha de entrega esperada: </strong></span>{{ row.item.CRMWhatsappInvoiceExpectedShippingDatetimeType == 'Exactamente' ? '' : row.item.CRMWhatsappInvoiceExpectedShippingDatetimeType }} {{ $displayFunctions.default.fromDatetimeToDDMMYYYY(row.item.CRMWhatsappInvoiceExpectedShippingDate) }} {{ row.item.CRMWhatsappInvoiceExpectedShippingTime ? `a las ${row.item.CRMWhatsappInvoiceExpectedShippingTime}` : '' }}</p>
                        </div>
                        <div v-if="row.item.CRMWhatsappInvoiceShippingCRMAgentID" style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-truck</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Agente de entrega: </strong></span>{{ display.shippingCRMAgent.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceShippingCRMAgentID) ? display.shippingCRMAgent.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappInvoiceShippingCRMAgentID).CRMAgentName : 'No registrado' }}</p>
                        </div>
                        <div style="display: flex; gap: 5px; align-items: center;">
                          <v-icon color="indigo">mdi-source-branch</v-icon>
                          <p><span style="color: #3F51B5;"><strong>Método: </strong></span>{{ row.item.CRMWhatsappInvoiceShippingMethod }}</p>
                        </div>
                        <div v-if="row.item.CRMWhatsappInvoiceShippingMethod == 'Envío mediante sistema'" style="display: flex; flex-direction: column; gap: 10px;">
                          <div style="display: flex; gap: 5px; align-items: center;">
                            <v-icon color="indigo">mdi-map-marker-path</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Tipo de ubicación: </strong></span>{{ row.item.CRMWhatsappContactLatitudeLongitudeLocationLatitude && row.item.CRMWhatsappContactLatitudeLongitudeLocationLongitude ? 'Ubicación de mapa' : 'Ubicación de URL' }}</p>
                          </div>
                          <div v-if="row.item.CRMWhatsappContactLatitudeLongitudeLocationLatitude && row.item.CRMWhatsappContactLatitudeLongitudeLocationLongitude" style="width: 100%; display: flex; flex-direction: column; gap: 10px;">
                            <div style="display: flex; gap: 5px; align-items: center;">
                              <v-icon color="indigo">mdi-map</v-icon>
                              <p><span style="color: #3F51B5;"><strong>Ubicación: </strong></span></p>
                            </div>
                            <MapComponent
                              :key="row.item.mapID"
                              :width="'100%'"
                              :height="'250px'"
                              :showPoint="true"
                              :showPointDrawPoint="true"
                              :showPointPoint="{latitude: parseFloat(row.item.CRMWhatsappContactLatitudeLongitudeLocationLatitude), longitude: parseFloat(row.item.CRMWhatsappContactLatitudeLongitudeLocationLongitude)}"
                              :showPointName="$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) + '\n' + $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false)"
                              :displayMaps="
                                systemInformationData.CRMLocalities.map(CRMLocality => 
                                ({
                                  'mapID': CRMLocality.CRMLocalityID,
                                  'mapName': CRMLocality.CRMLocalityName, 
                                  'mapColor': CRMLocality.CRMLocalityColor, 
                                  'mapFontColor': CRMLocality.CRMLocalityFontColor, 
                                  'mapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 
                                  'mapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude, 
                                  'mapPoints': CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                                  ({
                                    'mapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                                    'mapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                                  })),
                                  'mapDivisions': CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                                  ({
                                    'mapDivisionID': CRMLocalityMapDivision.CRMLocalityMapDivisionID,
                                    'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                                    'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                                    'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                                    'mapDivisionIsDisplayOnly': CRMLocalityMapDivision.CRMLocalityMapDivisionIsDisplayOnly,
                                    'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                                    ({
                                      'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                                      'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                                    }))
                                  }))
                                }))"
                            ></MapComponent>
                            <div style="display: flex; justify-content: center; font-size: small; gap: 20px;">
                              <p><span style="color: #3F51B5;"><strong>Lat: </strong></span>{{ row.item.CRMWhatsappContactLatitudeLongitudeLocationLatitude }}</p>
                              <p><span style="color: #3F51B5;"><strong>Long: </strong></span>{{ row.item.CRMWhatsappContactLatitudeLongitudeLocationLongitude }}</p>
                            </div>
                          </div>
                          <div v-else style="display: flex; gap: 5px; align-items: center;">
                            <v-icon color="indigo">mdi-map-marker-path</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Ubicación: </strong></span> <a :href="row.item.CRMWhatsappContactURLLocationURL" target="_blank" style="text-decoration: underline; color: #3F51B5; cursor: pointer;">{{ row.item.CRMWhatsappContactURLLocationURL }}</a></p>
                          </div>
                        </div>
                        <div v-if="['Envío mediante correo', 'Envío mediante encomienda'].includes(row.item.CRMWhatsappInvoiceShippingMethod)" style="display: flex; flex-direction: column; gap: 10px;">
                          <div style="display: flex; gap: 5px; align-items: center;">
                            <v-icon color="indigo">mdi-map-marker-path</v-icon>
                            <p><span style="color: #3F51B5;"><strong>Dirección: </strong></span></p>
                          </div>
                          <p style="white-space: pre-line;">{{ row.item.CRMWhatsappContactAddressAddress }}</p>
                        </div>
                      </div>
                    </v-card>
                  </v-menu>
                  <p v-else>{{ row.item.CRMWhatsappInvoiceShippingMethod }}</p>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceProducts' && navigation.tableVisibility[header.value]">
                  <v-menu :close-on-content-click="false" location="bottom" scrim>
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="primary" variant="flat" style="margin: 5px 0px;">
                        <v-icon size="small" style="margin-right: 10px;">mdi-package</v-icon>
                        <p style="font-size: small;">VER PRODUCTOS</p>
                      </v-btn>
                    </template>
                    <v-card width="850px" style="cursor: default; user-select: none;">
                      <v-data-table 
                        :headers="display.CRMWhatsappInvoiceProductHeaders" 
                        :items="row.item.CRMWhatsappInvoiceProducts" 
                        :items-per-page="-1" 
                        :fixed-header="true" 
                        style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;"
                      >
                        <template v-slot:headers="{ columns }">
                          <tr>
                            <th v-for="column in columns" :key="column.key">
                              <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 10px;">
                                <template v-if="!loader.getSystemInformation">
                                  <v-icon v-if="display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).index > 0" @click="updateProductTableHeaderIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                                  <v-icon v-if="display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).icon" color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).icon }}</v-icon>
                                  <span v-if="navigation.productTableVisibility[column.key] && display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).title" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).title }}</strong></span>
                                  <v-icon @click="navigation.productTableVisibility[column.key] = !navigation.productTableVisibility[column.key]; updateProductTableVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ navigation.productTableVisibility[column.key] ? 'eye' : 'eye-off' }}</v-icon>
                                  <v-icon v-if="display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == column.key).index < display.CRMWhatsappInvoiceProductHeaders.length - 1" @click="updateProductTableHeaderIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>
                                </template>
                              </v-card>
                            </th>
                          </tr>
                        </template>
                        <template v-slot:item="row">
                          <tr>
                            <td v-for="header in display.CRMWhatsappInvoiceProductHeaders.sort((a,b) => a.index - b.index)" :key="header.value">
                              <template v-if="header.value == 'CRMWhatsappInvoiceProductProductID' && navigation.productTableVisibility[header.value]">
                                <div style="display: flex; align-items: center; gap: 10px;">
                                  <img :src="row.item.CRMWhatsappInvoiceProductImageURL" draggable="false" style="width: 30px; height: 30px; object-fit: cover; border-radius: 50%;">
                                  <div style="white-space: nowrap;">
                                    <p style="font-size: small;">{{ row.item.CRMWhatsappInvoiceProductName }}</p>
                                    <p style="font-size: x-small; color: #3F51B5;"><strong>{{ row.item.CRMWhatsappInvoiceProductProductID }}</strong></p>
                                  </div>
                                </div>
                              </template>
                              <template v-else-if="header.value == 'CRMWhatsappInvoiceProductPrice' && navigation.productTableVisibility[header.value]">
                                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay((Math.round(row.item.CRMWhatsappInvoiceProductPrice / 5) * 5)) }}</p>
                              </template>
                              <template v-else-if="header.value == 'CRMWhatsappInvoiceProductAmount' && navigation.productTableVisibility[header.value]">
                                <p>{{ row.item.CRMWhatsappInvoiceProductAmount }}</p>
                              </template>
                              <template v-else-if="header.value == 'CRMWhatsappInvoiceProductSubtotal' && navigation.productTableVisibility[header.value]">
                                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay((Math.round(row.item.CRMWhatsappInvoiceProductPrice * row.item.CRMWhatsappInvoiceProductAmount / 5) * 5)) }}</p>
                              </template>
                              <template v-else-if="header.value == 'CRMWhatsappInvoiceProductDiscountMargin' && navigation.productTableVisibility[header.value]">
                                <p>{{ $displayFunctions.default.parseAmountToDisplay(Math.round(row.item.CRMWhatsappInvoiceProductDiscountMargin / 5) * 5) }}<span style="color: #3F51B5; margin-left: 5px;"><strong>%</strong></span></p>
                              </template>
                              <template v-else-if="header.value == 'CRMWhatsappInvoiceProductTotal' && navigation.productTableVisibility[header.value]">
                                <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay((Math.round(row.item.CRMWhatsappInvoiceProductPrice * row.item.CRMWhatsappInvoiceProductAmount * (1 - row.item.CRMWhatsappInvoiceProductDiscountMargin / 100)) / 5) * 5) }}</p>
                              </template>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:bottom v-if="row.item.CRMWhatsappInvoiceProducts.length <= 50"></template>
                      </v-data-table>
                      <v-data-table
                        :headers="display.CRMWhatsappInvoiceProductResultHeaders"
                        :items="[{}]"
                        :items-per-page="-1"
                        :fixed-header="true"
                        style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;"
                      >
                      <template v-slot:headers="{ columns }">
                        <tr>
                          <th v-for="column in columns" :key="column.key">
                            <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 10px;">
                              <template v-if="!loader.getSystemInformation">
                                <v-icon v-if="display.CRMWhatsappInvoiceProductResultHeaders.find(header => header.value == column.key).icon" color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappInvoiceProductResultHeaders.find(header => header.value == column.key).icon }}</v-icon>
                                <span v-if="display.CRMWhatsappInvoiceProductResultHeaders.find(header => header.value == column.key).title" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappInvoiceProductResultHeaders.find(header => header.value == column.key).title }}</strong></span>
                              </template>
                            </v-card>
                          </th>
                        </tr>
                      </template>
                      <template v-slot:item.CRMWhatsappInvoiceProductAmount>
                        <p>{{ row.item.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductAmount, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductAmount + CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount, 0) }}</p>
                      </template>
                      <template v-slot:item.CRMWhatsappInvoiceProductSubtotal>
                        <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay((Math.round(row.item.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceSubtotal, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceSubtotal + (CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount), 0) / 5) * 5)) }}</p>
                      </template>
                      <template v-slot:item.CRMWhatsappInvoiceProductDiscountMargin>
                        <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay(Math.round(row.item.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductDiscount, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductDiscount + (CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount) * (CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductDiscountMargin / 100), 0) / 5) * 5) }}</p>
                      </template>
                      <template v-slot:item.CRMWhatsappInvoiceProductTotal>
                        <p><span style="color: #3F51B5; margin-right: 5px;"><strong>₡</strong></span>{{ $displayFunctions.default.parseAmountToDisplay((Math.round(row.item.CRMWhatsappInvoiceProducts.reduce((CRMWhatsappInvoiceProductTotal, CRMWhatsappInvoiceProduct) => CRMWhatsappInvoiceProductTotal + (CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductPrice * CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductAmount) * (1 - CRMWhatsappInvoiceProduct.CRMWhatsappInvoiceProductDiscountMargin / 100), 0) / 5) * 5)) }}</p>
                      </template>
                      <template v-slot:bottom></template>
                      </v-data-table>
                    </v-card>
                  </v-menu>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappConversationID' && navigation.tableVisibility[header.value]">
                  <v-btn v-if="row.item.CRMWhatsappInvoiceCRMWhatsappConversationID" @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappInvoiceCRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, false, false)" color="primary" variant="flat" style="margin: 5px 0px;">
                    <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                    <p style="font-size: small;">VER CONVERSACIÓN</p>
                  </v-btn>
                  <p v-else>Sin conversación asociada</p>
                </template>
                <template v-else-if="header.value == 'CRMWhatsappInvoiceUpdates' && navigation.tableVisibility[header.value]">
                  <v-menu v-if="row.item.CRMWhatsappInvoiceUpdates.length > 0" :close-on-content-click="false" scrim location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="primary" variant="flat" style="margin: 5px 0px;">
                        <v-icon size="small" style="margin-right: 10px;">mdi-update</v-icon>
                        <p style="font-size: small;">VER ACTUALIZACIONES</p>
                      </v-btn>
                    </template>
                    <v-card width="850px" style="cursor: default; user-select: none;">
                      <v-data-table :headers="display.CRMWhatsappInvoiceUpdateHeaders" :items="row.item.CRMWhatsappInvoiceUpdates" :items-per-page="-1" :fixed-header="true" style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                        <template v-slot:headers="{ columns }">
                          <tr>
                            <th v-for="column in columns" :key="column.key">
                              <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 10px;"> 
                                <template v-if="!loader.getSystemInformation">
                                  <v-icon v-if="display.CRMWhatsappInvoiceUpdateHeaders.find(header => header.value == column.key).icon" color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappInvoiceUpdateHeaders.find(header => header.value == column.key).icon }}</v-icon>
                                  <span v-if="display.CRMWhatsappInvoiceUpdateHeaders.find(header => header.value == column.key).title" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappInvoiceUpdateHeaders.find(header => header.value == column.key).title }}</strong></span>
                                </template>
                              </v-card>
                            </th>
                          </tr>
                        </template>
                        <template v-slot:item.CRMWhatsappInvoiceUpdateID="{ item }">
                          <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID de la actualización" location="top">
                            <template v-slot:activator="{ props }">
                              <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la actualización de la orden', 'o', item.CRMWhatsappInvoiceUpdateID)" class="hoverableElement" style="color: #3F51B5"><strong>{{ item.CRMWhatsappInvoiceUpdateID }}</strong></p>
                            </template>
                          </v-tooltip>
                        </template>
                        <template v-slot:item.CRMWhatsappInvoiceUpdateFieldName="{ item }">
                          <p style="white-space: nowrap;">{{ 
                          {
                            'CRMWhatsappInvoiceCRMLocalityID': 'Localidad de entrega',
                            'CRMWhatsappInvoiceNote': 'Nota de la entrega',
                            'CRMWhatsappInvoiceExpectedShippingDatetimeType': 'Tipo de fecha de entrega',
                            'CRMWhatsappInvoiceExpectedShippingDate': 'Fecha de entrega',
                            'CRMWhatsappInvoiceExpectedShippingTime': 'Hora de entrega',
                            'CRMWhatsappInvoiceShippingMethod': 'Método de entrega',
                            'CRMWhatsappInvoiceCRMWhatsappContactLatitudeLongitudeLocationID': 'Ubicación del contacto',
                            'CRMWhatsappInvoiceCRMWhatsappContactURLLocationID': 'Ubicación del contacto',
                            'CRMWhatsappInvoiceCRMWhatsappContactAddressID': 'Dirección del contacto',
                            'CRMWhatsappInvoicePaymentMethod': 'Método de pago',
                            'CRMWhatsappInvoicePaymentState': 'Estado de pago',
                            'CRMWhatsappInvoiceMixedPaymentCashAmount': 'Monto de pago mixto en efectivo',
                            'CRMWhatsappInvoiceMixedPaymentCardAmount': 'Monto de pago mixto en tarjeta',
                            'CRMWhatsappInvoiceMixedPaymentSINPEAmount': 'Monto de pago mixto en SINPE',
                            'CRMWhatsappInvoiceMixedPaymentDepositAmount': 'Monto de pago mixto en depósito',
                            'CRMWhatsappInvoiceMixedPaymentWebpageAmount': 'Monto de pago mixto en plataforma digital',
                            'CRMWhatsappInvoiceRequireTaxedBill': 'Require factura electrónica'
                          }[item.CRMWhatsappInvoiceUpdateFieldName] 
                          }}</p>
                        </template>
                        <template v-slot:item.CRMWhatsappInvoiceUpdateFieldOldValue="{ item }">
                          <p style="max-width: 200px; max-height: 200px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">{{ item.CRMWhatsappInvoiceUpdateFieldOldValue }}</p>
                        </template>
                        <template v-slot:item.CRMWhatsappInvoiceUpdateFieldNewValue="{ item }">
                          <p style="max-width: 200px; max-height: 200px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">{{ item.CRMWhatsappInvoiceUpdateFieldNewValue }}</p>
                        </template>
                        <template v-slot:item.CRMWhatsappInvoiceUpdateCRMAgentID="{ item }">
                          <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentColor : 'primary'" variant="flat" label>
                            <div style="display: flex; align-items: center;">
                              <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentProfilePictureURL : require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                              <div style="display: flex; flex-direction: column;">
                                <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID) ? systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == item.CRMWhatsappInvoiceUpdateCRMAgentID).CRMAgentName : 'No registrado' }}</p>
                                <div style="display: flex; align-items: center; gap: 5px;">
                                  <v-icon size="xx-small">mdi-clock</v-icon>
                                  <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(item.CRMWhatsappInvoiceUpdateDatetime) }}</p>
                                </div>
                              </div>
                            </div>
                          </v-chip>
                        </template>
                        <template v-slot:bottom></template>
                      </v-data-table>
                    </v-card>
                  </v-menu>
                </template>
              </td>
            </template>
          </tr>
        </template>
        <template v-slot:loading>
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 30px;">
            <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-clock</v-icon>
            <p>Cargando lista de órdenes...</p>
          </div>
        </template>
        <template v-slot:no-data v-if="navigation.noData">
          <div @click="setDefaultValues()" class="hoverableText" style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 30px;">
            <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-information</v-icon>
            <p>No se ha encontrado ningún orden con los filtros seleccionados</p>
            <p>Haz click <span style="color: #3F51B5; text-decoration: underline;">aquí</span> para limpiar los filtros de búsqueda</p>
          </div>
        </template>
        <template v-slot:bottom></template>
      </v-data-table>
      
      <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
      <v-card elevation="0" rounded="0" color="primary" class="bottomContainer" style="padding: 10px; height: 60px; display: flex; justify-content: center; align-items: center;">
        <div v-if="display.CRMWhatsappInvoice.length > 0" class="paginator">
          <v-pagination
            v-model="input.page"
            :length="Math.ceil(display.CRMWhatsappInvoiceCount / navigation.limit)"
            :total-visible="5"
            density="compact"
            size="small"
            :disabled="loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewPagination"
          ></v-pagination>
          <p style="font-size: x-small;">{{ (display.CRMWhatsappInvoiceCount == 0) ? `0 de 0 conversaciones` : `${(input.page - 1) * navigation.limit + 1} - ${Math.min(input.page * navigation.limit, display.CRMWhatsappInvoiceCount)} de ${display.CRMWhatsappInvoiceCount} ${display.CRMWhatsappInvoiceCount > 1 ? 'conversaciones' : 'conversación'}`}}</p>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }

  .mainContainer {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin-top: 0;
    padding-top: 0;
  }
  .navigationContainer {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .navigationSearchContainer {
    flex: 1;
    width: 100%;
    padding: 15px;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
  }
  .paginator {
    margin-left: auto; 
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center;
  }

  @media (max-width: 1200px) {
    .hideSearchContainer {
      display: none;
    }
    .mainContainer {
      flex-direction: column;
      height: auto;
      overflow-y: auto;
    }
    .navigationContainer {
      width: 100%;
    }
    .contentContainer {
      min-height: 900px;
      max-height: 900px;
    }
    .hideSummaryTable {
      min-height: 50px;
      max-height: 50px;
      align-items: center;
      justify-content: center;
    }
    .bottomContainer {
      min-height: 80px;
      max-height: 80px;
      align-items: center;
      justify-content: center;
    }
    .paginator {
      margin-left: 0;
      justify-content: center;
      align-items: center;
    }
  }
</style>


<script setup>
  import { systemInformation } from '@/utilities/systemInformation';
  import { VDateInput } from 'vuetify/labs/VDateInput';
  import MapComponent from '@/components/MapComponent.vue';
  //import LZString from 'lz-string';
</script>

<script>
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      MapComponent
    },

    data: () => 
    ({
      input: 
      {
        CRMWhatsappInvoiceID: null,
        CRMWhatsappInvoiceCreationDatetime: [],
        CRMWhatsappInvoiceLocalityStartDatetime: [],
        CRMWhatsappInvoiceLocalityEndDatetime: [],
        CRMWhatsappInvoiceShippingStartDatetime: [],
        CRMWhatsappInvoiceShippingEndDatetime: [],
        CRMWhatsappContactIDSearch: null,
        CRMWhatsappContactID: null,
        CRMLocalityIDSearch: null,
        CRMLocalityID: [],
        allCRMLocalityIDSelected: false,
        CRMLocalityMapDivisionIDSearch: null,
        CRMLocalityMapDivisionID: [],
        allCRMLocalityMapDivisionIDSelected: false,
        CRMWhatsappInvoiceCreationCRMAgentIDSearch: null,
        CRMWhatsappInvoiceCreationCRMAgentID: [],
        allCRMWhatsappInvoiceCreationCRMAgentIDSelected: false,
        CRMWhatsappInvoiceShippingCRMAgentIDSearch: null,
        CRMWhatsappInvoiceShippingCRMAgentID: [],
        allCRMWhatsappInvoiceShippingCRMAgentIDSelected: false,
        CRMWhatsappInvoiceStateSearch: null,
        CRMWhatsappInvoiceState: [],
        allCRMWhatsappInvoiceStateSelected: false,
        CRMWhatsappInvoiceShippingMethodSearch: null,
        CRMWhatsappInvoiceShippingMethod: [],
        allCRMWhatsappInvoiceShippingMethodSelected: false,
        CRMWhatsappInvoicePaymentMethodSearch: null,
        CRMWhatsappInvoicePaymentMethod: [],
        allCRMWhatsappInvoicePaymentMethodSelected: false,
        CRMWhatsappInvoicePaymentStateSearch: null,
        CRMWhatsappInvoicePaymentState: [],
        allCRMWhatsappInvoicePaymentStateSelected: false,
        CRMWhatsappInvoiceIsBilled: null,
        CRMWhatsappInvoiceNote: null,
        productIDSearch: null,
        productID: null,
        productCategoryIDSearch: null,
        productCategoryID: [],
        allProductCategoryIDSelected: false,
        productBrandIDSearch: null,
        productBrandID: [],
        allProductBrandIDSelected: false,
        productModelIDSearch: null,
        productModelID: [],
        allProductModelIDSelected: false,
        productFlavorIDSearch: null,
        productFlavorID: [],
        allProductFlavorIDSelected: false,
        productNicotineLevelIDSearch: null,
        productNicotineLevelID: [],
        allProductNicotineLevelIDSelected: false,
        productSizeIDSearch: null,
        productSizeID: [],
        allProductSizeIDSelected: false,
        productProviderIDSearch: null,
        productProviderID: [],
        allProductProviderIDSelected: false,
        productTagIDSearch: null,
        productTagID: [],
        allProductTagIDSelected: false,
        CRMWhatsappConversationID: null,
        CRMWhatsappConversationStartDatetime: [],
        CRMWhatsappConversationEndDatetime: [],
        CRMWhatsappConversationCRMAgentIDSearch: null,
        CRMWhatsappConversationCRMAgentID: [],
        allCRMWhatsappConversationCRMAgentIDSelected: false,
        CRMWhatsappConversationNoteOrCRMWhatsappMessageNote: null,
        CRMWhatsappMessageContent: null,
        page: 1,
        updatedCRMWhatsappInvoiceState: null
      },
      display: 
      {
        CRMWhatsappContact: [],
        CRMLocalityMapDivision: [],
        shippingCRMAgent: [],
        CRMWhatsappInvoiceState: ['Orden generada', 'Orden en localidad', 'Orden en entrega', 'Orden no entregada', 'Orden entregada', 'Orden cancelada'],
        CRMWhatsappInvoiceShippingMethod: ['Envío mediante sistema', 'Envío mediante correo', 'Envío mediante encomienda', 'Envío mediante Uber Flash', 'Retiro en localidad'],
        CRMWhatsappInvoicePaymentMethod: ['Pago en efectivo', 'Pago en tarjeta', 'Pago en SINPE', 'Pago en transferencia', 'Pago en plataforma digital', 'Pago mixto'],
        CRMWhatsappInvoicePaymentState: ['Pagado', 'Pendiente', 'Pagado parcialmente'],
        CRMWhatsappInvoiceIsBilled: 
        [
          {'CRMWhatsappInvoiceIsBilledID': 1, 'CRMWhatsappInvoiceIsBilledName': 'Orden facturada'},
          {'CRMWhatsappInvoiceIsBilledID': 0, 'CRMWhatsappInvoiceIsBilledName': 'Orden no facturada'}
        ],
        product: [],
        productCategory: [],
        productBrand: [],
        productModel: [],
        productFlavor: [],
        productNicotineLevel: [],
        productSize: [],
        productProvider: [],
        productTag: [],
        CRMWhatsappInvoiceHeaders: [],
        CRMWhatsappInvoiceProductHeaders:
        [
          {title: 'PRODUCTO', value: 'CRMWhatsappInvoiceProductProductID', sortable: false, icon: 'mdi-package', index: 0},
          {title: 'PRECIO', value: 'CRMWhatsappInvoiceProductPrice', sortable: false, icon: 'mdi-cash', index: 1},
          {title: 'CANTIDAD', value: 'CRMWhatsappInvoiceProductAmount', sortable: false, icon: 'mdi-numeric', index: 2},
          {title: 'SUBTOTAL', value: 'CRMWhatsappInvoiceProductSubtotal', sortable: false, icon: 'mdi-cash', index: 3},
          {title: 'DESCUENTO', value: 'CRMWhatsappInvoiceProductDiscountMargin', sortable: false, icon: 'mdi-percent', index: 3},
          {title: 'TOTAL', value: 'CRMWhatsappInvoiceProductTotal', sortable: false, icon: 'mdi-cash', index: 4}
        ],
        CRMWhatsappInvoiceProductResultHeaders:
        [
          {title: 'UNIDADES', value: 'CRMWhatsappInvoiceProductAmount', sortable: false, icon: 'mdi-numeric'},
          {title: 'SUBTOTAL', value: 'CRMWhatsappInvoiceProductSubtotal', sortable: false, icon: 'mdi-cash'},
          {title: 'DESCUENTO', value: 'CRMWhatsappInvoiceProductDiscountMargin', sortable: false, icon: 'mdi-percent'},
          {title: 'TOTAL', value: 'CRMWhatsappInvoiceProductTotal', sortable: false, icon: 'mdi-cash'}
        ],
        CRMWhatsappInvoiceUpdateHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappInvoiceUpdateID', sortable: false, icon: 'mdi-barcode'},
          {title: 'DATO ACTUALIZADO', value: 'CRMWhatsappInvoiceUpdateFieldName', sortable: false, icon: 'mdi-information'},
          {title: 'VALOR ANTERIOR', value: 'CRMWhatsappInvoiceUpdateFieldOldValue', sortable: false, icon: 'mdi-calendar-start'},
          {title: 'VALOR NUEVO', value: 'CRMWhatsappInvoiceUpdateFieldNewValue', sortable: false, icon: 'mdi-calendar-end'},
          {title: 'ACTUALIZACIÓN', value: 'CRMWhatsappInvoiceUpdateCRMAgentID', sortable: false, icon: 'mdi-account'}
        ],
        CRMWhatsappInvoiceCount: 0,
        CRMWhatsappInvoice: []
      },
      navigation: 
      {
        searchVisible: true,
        limit: 50,
        noData: false,
        tableVisibility:
        {
          'CRMWhatsappInvoiceIsBilled': true,
          'CRMWhatsappInvoiceID': true,
          'CRMWhatsappContactID': true,
          'CRMWhatsappInvoiceCreationCRMAgentID': true,
          'CRMWhatsappInvoiceCRMLocalityID': true,
          'CRMWhatsappInvoiceState': true,
          'CRMWhatsappInvoiceTime': true,
          'CRMWhatsappInvoiceAmount': true,
          'CRMWhatsappInvoicePaymentMethod': true,
          'CRMWhatsappInvoiceShippingMethod': true,
          'CRMWhatsappInvoiceProducts': true,
          'CRMWhatsappConversationID': true,
          'CRMWhatsappInvoiceUpdates': true
        },
        productTableVisibility:
        {
          'CRMWhatsappInvoiceProductProductID': true,
          'CRMWhatsappInvoiceProductPrice': true,
          'CRMWhatsappInvoiceProductAmount': true,
          'CRMWhatsappInvoiceProductSubtotal': true,
          'CRMWhatsappInvoiceProductDiscountMargin': true,
          'CRMWhatsappInvoiceProductTotal': true
        },
        CRMWhatsappInvoiceUpdateTableVisibility:
        {
          'CRMWhatsappInvoiceUpdateFieldName': true,
          'CRMWhatsappInvoiceUpdateFieldOldValue': true,
          'CRMWhatsappInvoiceUpdateFieldNewValue': true,
          'CRMWhatsappInvoiceUpdateCRMAgentID': true
        },
        updateCRMWhatsappInvoiceMenuIsVisible: {}
      },
      loader: 
      {
        getSystemInformation: false,
        selectCRMShippingAgent: false,
        selectProductSearchParameters: false,
        autocompleteCRMWhatsappContact: false,
        selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView: false,
        selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewPagination: false
      },
      interval: 
      {
        autocompleteCRMWhatsappContactInterval: null,
        CRMWhatsappInvoiceDatetimeInterval: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMLocalities: [],
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    watch: 
    {
      'input.page': function(){
        if(this.display.CRMWhatsappInvoice.length > 0) this.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(false);
      }
    },

    methods:
    {
      async selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(newSearch){
        if (newSearch){
          this.input.page = 1;
          this.display.CRMWhatsappInvoiceCount = 0;
          this.display.CRMWhatsappInvoice.length = 0;
          this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView = true;
        }
        this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewPagination = true;
        const selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappInvoiceID': this.input.CRMWhatsappInvoiceID,
          'CRMWhatsappInvoiceCreationStartDatetime': this.input.CRMWhatsappInvoiceCreationDatetime.length > 0 ? this.input.CRMWhatsappInvoiceCreationDatetime[0] : null,
          'CRMWhatsappInvoiceCreationEndDatetime': this.input.CRMWhatsappInvoiceCreationDatetime.length > 0 ? this.input.CRMWhatsappInvoiceCreationDatetime[this.input.CRMWhatsappInvoiceCreationDatetime.length - 1] : null,
          'CRMWhatsappInvoiceLocalityStartStartDatetime': this.input.CRMWhatsappInvoiceLocalityStartDatetime.length > 0 ? this.input.CRMWhatsappInvoiceLocalityStartDatetime[0] : null,
          'CRMWhatsappInvoiceLocalityStartEndDatetime': this.input.CRMWhatsappInvoiceLocalityStartDatetime.length > 0 ? this.input.CRMWhatsappInvoiceLocalityStartDatetime[this.input.CRMWhatsappInvoiceLocalityStartDatetime.length - 1] : null,
          'CRMWhatsappInvoiceLocalityEndStartDatetime': this.input.CRMWhatsappInvoiceLocalityEndDatetime.length > 0 ? this.input.CRMWhatsappInvoiceLocalityEndDatetime[0] : null,
          'CRMWhatsappInvoiceLocalityEndEndDatetime': this.input.CRMWhatsappInvoiceLocalityEndDatetime.length > 0 ? this.input.CRMWhatsappInvoiceLocalityEndDatetime[this.input.CRMWhatsappInvoiceLocalityEndDatetime.length - 1] : null,
          'CRMWhatsappInvoiceShippingStartStartDatetime': this.input.CRMWhatsappInvoiceShippingStartDatetime.length > 0 ? this.input.CRMWhatsappInvoiceShippingStartDatetime[0] : null,
          'CRMWhatsappInvoiceShippingStartEndDatetime': this.input.CRMWhatsappInvoiceShippingStartDatetime.length > 0 ? this.input.CRMWhatsappInvoiceShippingStartDatetime[this.input.CRMWhatsappInvoiceShippingStartDatetime.length - 1] : null,
          'CRMWhatsappInvoiceShippingEndStartDatetime': this.input.CRMWhatsappInvoiceShippingEndDatetime.length > 0 ? this.input.CRMWhatsappInvoiceShippingEndDatetime[0] : null,
          'CRMWhatsappInvoiceShippingEndEndDatetime': this.input.CRMWhatsappInvoiceShippingEndDatetime.length > 0 ? this.input.CRMWhatsappInvoiceShippingEndDatetime[this.input.CRMWhatsappInvoiceShippingEndDatetime.length - 1] : null,
          'CRMWhatsappContactID': this.input.CRMWhatsappContactID,
          'CRMLocalityID': this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMLocalityID') ? this.systemInformationData.CRMLocalities.map(CRMLocality => CRMLocality.CRMLocalityID) : this.input.CRMLocalityID,
          'CRMLocalityMapDivisionID': this.input.CRMLocalityMapDivisionID,
          'CRMWhatsappInvoiceCreationCRMAgentID': this.input.CRMWhatsappInvoiceCreationCRMAgentID,
          'CRMWhatsappInvoiceShippingCRMAgentID': this.input.CRMWhatsappInvoiceShippingCRMAgentID,
          'CRMWhatsappInvoiceState': this.input.CRMWhatsappInvoiceState,
          'CRMWhatsappInvoiceShippingMethod': this.input.CRMWhatsappInvoiceShippingMethod,
          'CRMWhatsappInvoicePaymentMethod': this.input.CRMWhatsappInvoicePaymentMethod,
          'CRMWhatsappInvoicePaymentState': this.input.CRMWhatsappInvoicePaymentState,
          'CRMWhatsappInvoiceIsBilled': this.input.CRMWhatsappInvoiceIsBilled,
          'CRMWhatsappInvoiceNote': this.input.CRMWhatsappInvoiceNote,
          'productID': this.input.productID,
          'productCategoryID': this.input.productCategoryID,
          'productBrandID': this.input.productBrandID,
          'productModelID': this.input.productModelID,
          'productFlavorID': this.input.productFlavorID,
          'productNicotineLevelID': this.input.productNicotineLevelID,
          'productSizeID': this.input.productSizeID,
          'productProviderID': this.input.productProviderID,
          'productTagID': this.input.productTagID,
          'CRMWhatsappConversationID': this.input.CRMWhatsappConversationID,
          'CRMWhatsappConversationStartStartDatetime': this.input.CRMWhatsappConversationStartDatetime.length > 0 ? this.input.CRMWhatsappConversationStartDatetime[0] : null,
          'CRMWhatsappConversationStartEndDatetime': this.input.CRMWhatsappConversationStartDatetime.length > 0 ? this.input.CRMWhatsappConversationStartDatetime[this.input.CRMWhatsappConversationStartDatetime.length - 1] : null,
          'CRMWhatsappConversationEndStartDatetime': this.input.CRMWhatsappConversationEndDatetime.length > 0 ? this.input.CRMWhatsappConversationEndDatetime[0] : null,
          'CRMWhatsappConversationEndEndDatetime': this.input.CRMWhatsappConversationEndDatetime.length > 0 ? this.input.CRMWhatsappConversationEndDatetime[this.input.CRMWhatsappConversationEndDatetime.length - 1] : null,
          'CRMWhatsappConversationCRMAgentID': this.input.CRMWhatsappConversationCRMAgentID,
          'CRMWhatsappConversationNoteOrCRMWhatsappMessageNote': this.input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote,
          'CRMWhatsappMessageContent': this.input.CRMWhatsappMessageContent,
          'page': this.input.page,
          'limit': this.navigation.limit
        };
        const selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView', selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewRequestQuery);
        if (selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewResult.success){
          this.display.CRMWhatsappInvoiceCount = selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewResult.result.CRMWhatsappInvoiceCount;
          this.display.CRMWhatsappInvoice = selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewResult.result.CRMWhatsappInvoice.map(CRMWhatsappInvoice => ({
            ...CRMWhatsappInvoice,
            'mapID': Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
          }));
          this.navigation.noData = this.display.CRMWhatsappInvoiceCount == 0;
          this.startCRMWhatsappInvoiceDatetimeInterval();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView_error', 'error', 'Ha ocurrido un error inesperado al consultar la lista de órdenes, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView = false;
        this.loader.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesViewPagination = false;
      },

      async updateCRMWhatsappInvoiceState(CRMWhatsappInvoice){
        const backupCRMWhatsappInvoiceState = JSON.parse(JSON.stringify(CRMWhatsappInvoice)).CRMWhatsappInvoiceState;
        CRMWhatsappInvoice.CRMWhatsappInvoiceState = this.input.updatedCRMWhatsappInvoiceState;
        CRMWhatsappInvoice.loader = true;
        const updateCRMWhatsappInvoiceStateRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappInvoiceID': CRMWhatsappInvoice.CRMWhatsappInvoiceID,
          'CRMWhatsappInvoiceState': this.input.updatedCRMWhatsappInvoiceState
        };
        const updateCRMWhatsappInvoiceStateResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappInvoice/functions/updateCRMWhatsappInvoiceStateFromCRMWhatsappInvoicesView', updateCRMWhatsappInvoiceStateRequestQuery);
        if (updateCRMWhatsappInvoiceStateResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappInvoiceState_success', 'success', `Se ha actualizado el estado de la orden ${CRMWhatsappInvoice.CRMWhatsappInvoiceID} a ${this.input.updatedCRMWhatsappInvoiceState}`, null, false);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappInvoiceState_error', 'error', `Ha ocurrido un error inesperado al actualizar el estado de la orden ${CRMWhatsappInvoice.CRMWhatsappInvoiceID} a ${this.input.updatedCRMWhatsappInvoiceState}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          CRMWhatsappInvoice.CRMWhatsappInvoiceState = backupCRMWhatsappInvoiceState;
        }
        CRMWhatsappInvoice.loader = false;
      },

      async selectCRMShippingAgent(){
        this.loader.selectCRMShippingAgent = true;
        const selectCRMShippingAgentRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
          }
        };
        const selectCRMShippingAgentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/systemInformation/selectShippingCRMAgents', selectCRMShippingAgentRequestQuery);
        if (selectCRMShippingAgentResult.success){
          this.display.shippingCRMAgent = selectCRMShippingAgentResult.result;
          this.loader.selectCRMShippingAgent = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMShippingAgent_error', 'error', 'Ha ocurrido un error inesperado al consultar los agentes de envío, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },

      async selectProductSearchParameters(){
        this.loader.selectProductSearchParameters = true;
        const selectProductSearchParametersRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectProductSearchParametersResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/product/functions/selectProductSearchParameters', selectProductSearchParametersRequestQuery);
        if (selectProductSearchParametersResult.success) {
          this.display.product = selectProductSearchParametersResult.result.products.map(product => ({
            'productID': product.productID,
            'productName': `${product.productID} - ${product.productName}`
          }));
          this.display.productCategory = selectProductSearchParametersResult.result.productCategories;
          this.display.productBrand = selectProductSearchParametersResult.result.productBrands;
          this.display.productModel = selectProductSearchParametersResult.result.productModels;
          this.display.productFlavor = selectProductSearchParametersResult.result.productFlavors;
          this.display.productNicotineLevel = selectProductSearchParametersResult.result.productNicotineLevels;
          this.display.productSize = selectProductSearchParametersResult.result.productSizes;
          this.display.productProvider = selectProductSearchParametersResult.result.productProviders;
          this.display.productTag = selectProductSearchParametersResult.result.productTags;
          this.loader.selectProductSearchParameters = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectProductSearchParameters_error', 'error', 'Ha ocurrido un error inesperado al consultar los parámetros de búsqueda de productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },

      async autocompleteCRMWhatsappContact(){
        if (this.interval.autocompleteCRMWhatsappContactInterval) {
          clearTimeout(this.interval.autocompleteCRMWhatsappContactInterval);
          this.interval.autocompleteCRMWhatsappContactInterval = null;
        }
        if (this.input.CRMWhatsappContactIDSearch && /\S/.test(this.input.CRMWhatsappContactIDSearch)){
          this.interval.autocompleteCRMWhatsappContactInterval = setTimeout(async () => {
            this.loader.autocompleteCRMWhatsappContact = true;
            if (!this.input.CRMWhatsappContactIDSearch) {
              this.display.CRMWhatsappContact.length = 0;
              this.loader.autocompleteCRMWhatsappContact = false;
              this.$generalFunctions.default.blurInput(this, 'CRMWhatsappContactIDSearch');
              return;
            }
            const autocompleteCRMWhatsappContactRequestQuery =
            {
              'localStorage': 
              {
                'CRMAccountID': this.systemInformationData.CRMAccountID
              },
              'CRMWhatsappContactSearch': this.input.CRMWhatsappContactIDSearch
            };
            const autocompleteCRMWhatsappContactResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/functions/autocompleteCRMWhatsappContact', autocompleteCRMWhatsappContactRequestQuery);
            if (autocompleteCRMWhatsappContactResult.success) {
              this.display.CRMWhatsappContact = autocompleteCRMWhatsappContactResult.result;
              if (this.display.CRMWhatsappContact.length == 0) this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_noResults', 'info', 'No se ha encontrado ningún contacto con el nombre buscado', null, false);
              else {
                this.display.CRMWhatsappContact.forEach(CRMWhatsappContact => {
                  CRMWhatsappContact.CRMWhatsappContactName = `${CRMWhatsappContact.CRMWhatsappContactName} - ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(CRMWhatsappContact.CRMWhatsappContactPhoneNumber, false)}`;
                  delete CRMWhatsappContact.CRMWhatsappContactPhoneNumber;
                });
              }
            } else {
              this.$root.notificationDialog.showSystemNotificationDialog('autocompleteCRMWhatsappContact_error', 'error', 'Ha ocurrido un error inesperado al consultar los contactos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
            }
            this.loader.autocompleteCRMWhatsappContact = false;          
          }, 1000);
        }
      },

      scanProduct(){
        const scannedProduct = this.display.product.find(product => product.productID == this.input.productIDSearch);
        if (scannedProduct){
          this.input.productID = scannedProduct.productID;
          this.input.productIDSearch = scannedProduct.productName;
          this.updateURLSearchQuery();
          this.selectCRMWhatsappInvoiceFromCRMWhatsappInvoicesView(true);
          this.$generalFunctions.default.blurInput(this, 'productID');
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('scanProduct_error', 'error', 'No se ha encontrado ningún producto con el código de barras escaneado', null, false);
        }
      },
      startCRMWhatsappInvoiceDatetimeInterval(){
        if (this.interval.CRMWhatsappInvoiceDatetimeInterval){
          clearInterval(this.interval.CRMWhatsappInvoiceDatetimeInterval);
          this.interval.CRMWhatsappInvoiceDatetimeInterval = null;
        }
        if (this.interval.CRMWhatsappInvoiceDatetimeInterval) clearInterval(this.interval.CRMWhatsappInvoiceDatetimeInterval);
        this.interval.CRMWhatsappInvoiceDatetimeInterval = setInterval(() => {
          this.display.CRMWhatsappInvoice.forEach(CRMWhatsappInvoice => {
            if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden generada'){
              CRMWhatsappInvoice.CRMWhatsappInvoiceCRMEndDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityStartDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityEndDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceShippingStartDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
            }
            else if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden en localidad'){
              CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityEndDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceShippingStartDatetime = new Date();
              CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
            }
            else if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden en entrega'){
              CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
            }
          });
        }, 1000);
        this.display.CRMWhatsappInvoice.forEach(CRMWhatsappInvoice => {
          if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden generada'){
            CRMWhatsappInvoice.CRMWhatsappInvoiceCRMEndDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityStartDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityEndDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceShippingStartDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
          }
          else if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden en localidad'){
            CRMWhatsappInvoice.CRMWhatsappInvoiceLocalityEndDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceShippingStartDatetime = new Date();
            CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
          }
          else if (CRMWhatsappInvoice.CRMWhatsappInvoiceState == 'Orden en entrega'){
            CRMWhatsappInvoice.CRMWhatsappInvoiceShippingEndDatetime = new Date();
          }
        }, 1000);
      },
      setDefaultValues(){
        this.input.CRMWhatsappInvoiceID = null;
        this.input.CRMWhatsappInvoiceCreationDatetime = this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? Array.from({length: 30}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(29-i)); return d.toISOString().split('T')[0]; }) : Array.from({length: 7}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(6-i)); return d.toISOString().split('T')[0]; });
        this.input.CRMWhatsappInvoiceLocalityStartDatetime.length = 0;
        this.input.CRMWhatsappInvoiceLocalityEndDatetime.length = 0;
        this.input.CRMWhatsappInvoiceShippingStartDatetime.length = 0;
        this.input.CRMWhatsappInvoiceShippingEndDatetime.length = 0;
        this.input.CRMWhatsappContactIDSearch = null;
        this.input.CRMWhatsappContactID = null;
        this.input.CRMLocalityIDSearch = null;
        this.input.CRMLocalityID.length = 0;
        this.input.allCRMLocalityIDSelected = false;
        this.input.CRMLocalityMapDivisionIDSearch = null;
        this.input.CRMLocalityMapDivisionID.length = 0;
        this.input.allCRMLocalityMapDivisionIDSelected = false;
        this.input.CRMWhatsappInvoiceCreationCRMAgentIDSearch = null;
        this.input.CRMWhatsappInvoiceCreationCRMAgentID.length = 0;
        this.input.allCRMWhatsappInvoiceCreationCRMAgentIDSelected = false;
        this.input.CRMWhatsappInvoiceShippingCRMAgentIDSearch = null;
        this.input.CRMWhatsappInvoiceShippingCRMAgentID.length = 0;
        this.input.allCRMWhatsappInvoiceShippingCRMAgentIDSelected = false;
        this.input.CRMWhatsappInvoiceStateSearch = null;
        this.input.CRMWhatsappInvoiceState.length = 0;
        this.input.allCRMWhatsappInvoiceStateSelected = false;
        this.input.CRMWhatsappInvoiceShippingMethodSearch = null;
        this.input.CRMWhatsappInvoiceShippingMethod.length = 0;
        this.input.allCRMWhatsappInvoiceShippingMethodSelected = false;
        this.input.CRMWhatsappInvoicePaymentMethodSearch = null;
        this.input.CRMWhatsappInvoicePaymentMethod.length = 0;
        this.input.allCRMWhatsappInvoicePaymentMethodSelected = false;
        this.input.CRMWhatsappInvoicePaymentStateSearch = null;
        this.input.CRMWhatsappInvoicePaymentState.length = 0;
        this.input.allCRMWhatsappInvoicePaymentStateSelected = false;
        this.input.CRMWhatsappInvoiceIsBilled = null;
        this.input.CRMWhatsappInvoiceNote = null;
        this.input.productIDSearch = null;
        this.input.productID = null;
        this.input.productCategoryIDSearch = null;
        this.input.productCategoryID.length = 0;
        this.input.allProductCategoryIDSelected = false;
        this.input.productBrandIDSearch = null;
        this.input.productBrandID.length = 0;
        this.input.allProductBrandIDSelected = false;
        this.input.productModelIDSearch = null;
        this.input.productModelID.length = 0;
        this.input.allProductModelIDSelected = false;
        this.input.productFlavorIDSearch = null;
        this.input.productFlavorID.length = 0;
        this.input.allProductFlavorIDSelected = false;
        this.input.productNicotineLevelIDSearch = null;
        this.input.productNicotineLevelID.length = 0;
        this.input.allProductNicotineLevelIDSelected = false;
        this.input.productSizeIDSearch = null;
        this.input.productSizeID.length = 0;
        this.input.allProductSizeIDSelected = false;
        this.input.productProviderIDSearch = null;
        this.input.productProviderID.length = 0;
        this.input.allProductProviderIDSelected = false;
        this.input.productTagIDSearch = null;
        this.input.productTagID.length = 0;
        this.input.allProductTagIDSelected = false;
        this.input.CRMWhatsappConversationID = null;
        this.input.CRMWhatsappConversationStartDatetime.length = 0;
        this.input.CRMWhatsappConversationEndDatetime.length = 0;
        this.input.CRMWhatsappConversationCRMAgentIDSearch = null;
        this.input.CRMWhatsappConversationCRMAgentID.length = 0;
        this.input.allCRMWhatsappConversationCRMAgentIDSelected = false;
        this.input.CRMWhatsappConversationNoteOrCRMWhatsappMessageNote = null;
        this.input.CRMWhatsappMessageContent = null;
        this.input.page = 1;
        this.input.updatedCRMWhatsappInvoiceState = null;
        this.display.CRMWhatsappInvoiceCount = 0;
        this.display.CRMWhatsappInvoice.length = 0;
        this.navigation.noData = false;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappInvoiceID');
        this.updateURLSearchQuery();
      },

      updateURLSearchQuery(){
        if (this.input.CRMWhatsappInvoiceCreationDatetime.length == 0) this.input.CRMWhatsappInvoiceCreationDatetime = this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1' ? Array.from({length: 30}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(29-i)); return d.toISOString().split('T')[0]; }) : Array.from({length: 7}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(6-i)); return d.toISOString().split('T')[0]; });
      },

      async decodeURLSearchQuery(){
        if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/selectAllDate')?.CRMAgentPermissionValue == '1') this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: 30}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(29-i)); return d.toISOString().split('T')[0]; });
        else this.input.CRMWhatsappInvoiceCreationDatetime = Array.from({length: 7}, (_, i) => { let d=new Date(); d.setDate(d.getDate()-(6-i)); return d.toISOString().split('T')[0]; });
        
      },

      updateTableVisibility(){
        localStorage.setItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceHeadersVisibility', JSON.stringify(this.navigation.tableVisibility));      
      },
      updateTableHeaderIndex(headerKey, indexChange) {
        const updatedTableHeader = this.display.CRMWhatsappInvoiceHeaders.find(header => header.value == headerKey);
        const swappedTableHeader = this.display.CRMWhatsappInvoiceHeaders.find(header => header.index == (this.display.CRMWhatsappInvoiceHeaders.find(header => header.value == headerKey).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        const headers = this.display.CRMWhatsappInvoiceHeaders.reduce((headers, header) => {headers[header.value] = header.index; return headers;}, {});
        localStorage.setItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceHeadersIndex', JSON.stringify(headers));      
      },
      updateProductTableVisibility(){
        localStorage.setItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceProductHeadersVisibility', JSON.stringify(this.navigation.productTableVisibility));      
      },
      updateProductTableHeaderIndex(headerKey, indexChange) {
        const updatedTableHeader = this.display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == headerKey);
        const swappedTableHeader = this.display.CRMWhatsappInvoiceProductHeaders.find(header => header.index == (this.display.CRMWhatsappInvoiceProductHeaders.find(header => header.value == headerKey).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        const headers = this.display.CRMWhatsappInvoiceProductHeaders.reduce((headers, header) => {headers[header.value] = header.index; return headers;}, {});
        localStorage.setItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceProductHeadersIndex', JSON.stringify(headers));      
      },
      async prepareTable() {
        this.display.CRMWhatsappInvoiceHeaders = 
        [
          {title: null, value: 'CRMWhatsappInvoiceIsBilled', sortable: false, icon: null, index: 0},
          {title: 'ID', value: 'CRMWhatsappInvoiceID', sortable: false, icon: 'mdi-barcode', index: 1},
          {title: 'TIEMPOS', value: 'CRMWhatsappInvoiceTime', sortable: false, icon: 'mdi-clock', index: 2},
          {title: 'CONTACTO', value: 'CRMWhatsappContactID', sortable: false, icon: 'mdi-account', index: 3},
          {title: 'ESTADO', value: 'CRMWhatsappInvoiceState', sortable: false, icon: 'mdi-timeline', index: 4},
          {title: 'LOCALIDAD', value: 'CRMWhatsappInvoiceCRMLocalityID', sortable: false, icon: 'mdi-store', index: 5},
          {title: 'VENDEDOR', value: 'CRMWhatsappInvoiceCreationCRMAgentID', sortable: false, icon: 'mdi-briefcase-account', index: 6},
          {title: 'VENTA', value: 'CRMWhatsappInvoiceAmount', sortable: false, icon: 'mdi-cash', index: 7},
          {title: 'PAGO', value: 'CRMWhatsappInvoicePaymentMethod', sortable: false, icon: 'mdi-cash-refund', index: 8},
          {title: 'ENTREGA', value: 'CRMWhatsappInvoiceShippingMethod', sortable: false, icon: 'mdi-map-marker', index: 9},
          {title: 'PRODUCTOS', value: 'CRMWhatsappInvoiceProducts', sortable: false, icon: 'mdi-package', index: 10},
          {title: 'ACTUALIZACIONES', value: 'CRMWhatsappInvoiceUpdates', sortable: false, icon: 'mdi-update', index: 11},
          ...(this.systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMWhatsappConversation')?.CRMAgentPermissionValue == '1' ? [{title: 'CONVERSACIÓN', value: 'CRMWhatsappConversationID', sortable: false, icon: 'mdi-chat', index: 12}] : []),
        ];
        let headersVisibility;
        try { headersVisibility = JSON.parse(localStorage.getItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceHeadersVisibility')); }
        catch { headersVisibility = null; }
        for (const headerKey in headersVisibility){
          if (this.navigation.tableVisibility[headerKey]) this.navigation.tableVisibility[headerKey] = headersVisibility[headerKey] 
        }
        let headersIndex;
        try { headersIndex = JSON.parse(localStorage.getItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceHeadersIndex')); }
        catch { headersIndex = null; }
        this.display.CRMWhatsappInvoiceHeaders = this.display.CRMWhatsappInvoiceHeaders.map(header => ({ ...header, index: headersIndex?.[header.value] ?? Infinity })).sort((headerA, headerB) => headerA.index - headerB.index).map((header, i) => ({ ...header, index: i }));

        let productHeadersVisibility;
        try { productHeadersVisibility = JSON.parse(localStorage.getItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceProductHeadersVisibility')); }
        catch { productHeadersVisibility = null; }
        for (const headerKey in productHeadersVisibility){
          if (this.navigation.productTableVisibility[headerKey]) this.navigation.productTableVisibility[headerKey] = productHeadersVisibility[headerKey] 
        }
        let productHeadersIndex;
        try { productHeadersIndex = JSON.parse(localStorage.getItem('CRMWhatsappInvoicesView_CRMWhatsappInvoiceProductHeadersIndex')); }
        catch { productHeadersIndex = null; }
        this.display.CRMWhatsappInvoiceProductHeaders = this.display.CRMWhatsappInvoiceProductHeaders.map(header => ({ ...header, index: productHeadersIndex?.[header.value] ?? Infinity })).sort((headerA, headerB) => headerA.index - headerB.index).map((header, i) => ({ ...header, index: i }));
        this.loader.getSystemInformation = false;
      },
      async getSystemInformation(){
        this.loader.getSystemInformation = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            if (this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMLocalityID')){
              let CRMLocalityIDPermissions = JSON.parse(this.systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMWhatsappInvoices/CRMLocalityID').CRMAgentPermissionValue);
              if (CRMLocalityIDPermissions.length > 0) this.systemInformationData.CRMLocalities = this.systemInformationData.CRMLocalities.filter(
                CRMLocality => CRMLocality.CRMLocalityID != null && CRMLocality.CRMLocalityID != undefined && CRMLocalityIDPermissions.includes(CRMLocality.CRMLocalityID)
              );
            }
            this.display.CRMLocalityMapDivision = this.systemInformationData.CRMLocalities.flatMap(CRMLocality => 
              CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => ({
                'CRMLocalityMapDivisionID': CRMLocalityMapDivision.CRMLocalityMapDivisionID,
                'CRMLocalityMapDivisionName': `${CRMLocalityMapDivision.CRMLocalityMapDivisionName} (${CRMLocality.CRMLocalityName})`,
              }))
            );
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformation = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted(){
      await this.getSystemInformation();
      await Promise.all([
        this.selectCRMShippingAgent(),
        this.selectProductSearchParameters()
      ]);
      await this.prepareTable();
      await this.decodeURLSearchQuery();
      this.$generalFunctions.default.focusInput(this, 'CRMWhatsappInvoiceID');
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
      if (this.interval.CRMWhatsappInvoiceDatetimeInterval){
        clearInterval(this.interval.CRMWhatsappInvoiceDatetimeInterval);
        this.interval.CRMWhatsappInvoiceDatetimeInterval = null;
      }
    }
  }
</script>